import React from 'react'
function Downloadpage(props) {

    var newArray = [// Computer science - SEMESTER -1 (ONE)
    {
        branch: "Computer Science",
        sem: "1",
        sub: "Applied physics-I",
        title: "Notes in hindi",
        descp: "Physics hindi hand written notes !",
        link: "https://drive.google.com/file/d/17u9I56JAhPDxXFFwmWOwVzfQCnXikCNe/view?usp=sharing"
    },
    // {
    //     branch: "Computer Science",
    //     sem: "1",
    //     sub: "Applied physics-I",
    //     title: " Notes in english",
    //     descp: "Physics english hand written notes !!",
        
    // },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "Applied physics-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1RI6k5UR1ka2QcCJtBKZeSaTKerrOXUzh/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "Applied physics-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1VLQX0fjeJx38uwIuEeRpO8505Ys_uzi-/view?usp=sharing"
    },
    // {
    //     branch: "Computer Science",
    //     sem: "1",
    //     sub: "Applied physics-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
                 
    // },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "Applied physics-I",
        title: "Important topics numericals ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/1WRfH9p-5_6kaPAipZqVeFzJgs_k9rLgq/view?usp=share_link",
        
    },


    {
        branch: "Computer Science",
        sem: "1",
        sub: "Applied physics-I",
        title: "Practicle file ",
        descp: "Available in English !!",
        link: "https://drive.google.com/file/d/1EB7aNuaZ0N0he2A6ZneJqIRK3_TCnuH5/view?usp=sharing"
    },

    {
        branch: "Computer Science",
        sem: "1",
        sub: "Applied physics-I",
        title: "Practicle file ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/10jeB6jiZOh9FIe0o4Fl-Ci11gdFWZlac/view?usp=sharing"
    },






    {
        branch: "Computer Science",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Syllabus",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/13mxEj4gGKE-WwNM9nU4qPcXHBSJayLuc/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Previous Year Question English",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/1hLfaeVv2GRPv1LFcDFT4hkBGCaciLo4r/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Previous Year Question Hindi",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/19nGARPnrWqvGQuapxPItNlU1T8MBMuLd/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "Applied chemistry",
        title: "Notes in hindi",
        descp: "Chemistry hindi hand written notes!",
        link:"https://drive.google.com/file/d/197yQ7Fm-7aUNUkErtk_2OVnr4C55WrEa/view?usp=sharing"
    },
    // {
    //     branch: "Computer Science",
    //     sem: "1",
    //     sub: "Applied chemistry",
    //     title: " Notes in english",
    //     descp: "Chemistry english hand written notes!",
        
    // },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "Applied chemistry",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1U7RP-S-j1ghwoA05ve_Hf2NjbQUEPXBd/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "Applied chemistry",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1kRQ0APZGFRMMPmmy2LdzgOuANAoLJQbk/view?usp=sharing"
    },
    // {
    //     branch: "Computer Science",
    //     sem: "1",
    //     sub: "Applied chemistry",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
        
    // },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "Applied chemistry",
        title: "Important topics ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/1WJye-HzI5_fZ1h5kwmCecglImIaar1f7/view?usp=sharing",
    },




    {
        branch: "Computer Science",
        sem: "1",
        sub: "Applied chemistry",
        title: "Practicle file ",
        descp: "Available in English !!",
        link: "https://drive.google.com/file/d/1-v1VAqErxYIzoTXAUrzo5JeakaG1JCUB/view?usp=sharing"
    },

    // {
    //     branch: "Computer Science",
    //     sem: "1",
    //     sub: "Applied chemistry",
    //     title: "Practicle file ",
    //     descp: "Available in hindi !!",
        
    // },


    {
        branch: "Computer Science",
        sem: "1",
        sub: "Communication Skill-I",
        title: "Notes in english",
        descp: "Communication english hand written notes!",
        link:"https://drive.google.com/file/d/1WOsiVeWiO1IcBszjChFagN2tilyz9DNs/view?usp=sharing"
        
    },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "Communication Skill-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1V0-XevYP2xI7aGDSMpsJr5Xcc-tgdfPv/view?usp=sharing"
    },

    {
        branch: "Computer Science",
        sem: "1",
        sub: "Communication Skill-I",
        title: "Important topics ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1WOsiVeWiO1IcBszjChFagN2tilyz9DNs/view?usp=sharing",
        
    },
    
    // {
    //     branch: "Computer Science",
    //     sem: "1",
    //     sub: "Technical drawing",
    //     title: "Notes in hindi",
    //     descp: "Technical drawing in hindi!",
        
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "1",
    //     sub: "technical drawing",
    //     title: " Notes in english ",
    //     descp: "Technical drwing in english!",
        
    // },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "Technical drawing",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1mDN6at540cjtZnwhUUjFBWueI2a3uVfV/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "Technical drawing",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1Co9WTIont896qEJZqMUkPk7HtXIiejnA/view?usp=sharing"
    },
    // {
    //     branch: "Computer Science",
    //     sem: "1",
    //     sub: "Technical drawing",
    //     title: "Important topics ",
    //     descp: "Available in english"
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "1",
    //     sub: "Technical drawing",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
        
    // },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "FCIT",
        title: "Notes in hindi",
        descp: "FCIT hand written notes  in hindi!",
        link: "https://drive.google.com/file/d/17vvCoBDS7Z8yPyKu1prF1UPAccM9XxB8/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "FCIT",
        title: "Notes in english",
        descp: "FCIT hand written notes in english!",
        link:"https://drive.google.com/file/d/1el00azf7P-Ef1dzbzfimCBxbDCB-hdui/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "FCIT",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1oO4Q-5i9vs5eybfcbGVJBVougHd6Unwg/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "FCIT",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1oZ7eCmCYTNtgfYnoDzqQmRrtnq3m0LMP/view?usp=sharing"
    },
    // {
    //     branch: "Computer Science",
    //     sem: "1",
    //     sub: "FCIT",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
    
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "1",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
    
    // },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "Workshop",
        title: " in hindi",
        descp: "Hand written workshop in hindi!",
        link:"https://drive.google.com/file/d/14Katdl6sFCLD-TZZcN69FTOGmB2kht64/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "1",
        sub: "Workshop",
        title: "in english",
        descp: "Hand written workshop in english!",
        link: "https://drive.google.com/file/d/1-hwPUqPFP0Of0kNGTrlw7t3MhwpZ83Ks/view?usp=sharing"
    },



    {
        branch: "Computer Science",
        sem: "1",
        sub: "Technical Drawing",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1YARpBtApCYVvfaurk3u-U51p0pFsGaVY/view?usp=share_link"
    },

    {
        branch: "Computer Science",
        sem: "1",
        sub: "Technical Drawing",
        title: "Previous year question paper(last year) ",
        descp: "Available in Hindi !!",
        link: "https://drive.google.com/file/d/1YDFuJ1iZOEEZEcpOCNbdAdI4E8VXfgRX/view?usp=share_link"
    },
    // -----------------------------------------------------
    // Computer science - SEMESTER - 2 (TWO)

    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Multimedia & Animation",
    //     title: "Hand written Notes in hindi",
    //     descp: "Physics hindi hand written notes !",
        
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Multimedia & Animation",
    //     title: " Hand written Notes in english",
    //     descp: "Physics english hand written notes !!",
        
    // },
    {
        branch: "Computer Science",
        sem: "2",
        sub: "Multimedia & Animation",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1xmaWS-txheP3ml1wnf1dSLaIiEfoT6mP/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "2",
        sub: "Multimedia & Animation",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1Gey2jJejUCMPc5qShXsOSkwOy4q9zeIK/view?usp=sharing"
    },
    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Multimedia & Animation",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
        
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Multimedia & Animation",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
        
    // },

    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Multimedia & Animation",
    //     title: "Practicle file ",
    //     descp: "Available in English !!",
        
    // },

    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Multimedia & Animation",
    //     title: "Practicle file ",
    //     descp: "Available in hindi !!",
        
    // },


    {
        branch: "Computer Science",
        sem: "2",
        sub: "BEE",
        title: "Hand written Notes in hindi",
        descp: "BEEE hindi hand written notes!",
        link: "https://drive.google.com/file/d/14-n_YokN58EOoXxyzE04yuxrJ7OHuX_N/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "2",
        sub: "BEE",
        title: " Hand written Notes in english",
        descp: "BEEE english hand written notes!",
    
    },
    {
        branch: "Computer Science",
        sem: "2",
        sub: "BEE",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1D7VknypvmUTj1pBm2zj1-asBQLr4MKrI/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "2",
        sub: "BEE",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1BsyYB0KFPLOS8NMLNzA3B-IB2FjTJTfF/view?usp=sharing"
    },
    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "BEE",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
        
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "BEE",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
        
    // },

    {
        branch: "Computer Science",
        sem: "2",
        sub: "BEE",
        title: "Practicle file ",
        descp: "Available in English !!",
        link: "https://drive.google.com/file/d/1-hp1Dc-9hBV1ULsj-Vv-XSQ4W5G-Ee1o/view?usp=sharing"
    },

    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "BEE",
    //     title: "Practicle file ",
    //     descp: "Available in hindi !!",
        
    // },


    {
        branch: "Computer Science",
        sem: "2",
        sub: "Concept of programming using c",
        title: "Hand written Notes in hindi",
        descp: "Concept of programming using c in hindi!",
        link: "https://drive.google.com/file/d/14-R21eJpqmLCK31hYM5F9G0m5IbRlF7c/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "2",
        sub: "Concept of programming using c",
        title: " Hand written Notes in english ",
        descp: "Available in english!",
        link: "https://drive.google.com/file/d/15Cq4TqF2LHirxCGrgnOQ4hdfynoEp0Cd/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "2",
        sub: "Concept of programming using c",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/15eybm1qYi-5Qe5ob22KrGheUe8TWalh7/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "2",
        sub: "Concept of programming using c",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1dhRG2KUbfjufuy62FHHGtfHtf7fIbt7P/view?usp=sharing"
    },
    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Concept of programming using c",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
    
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Concept of programming using c",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
        
    // },



    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Concept of programming using c",
    //     title: "Practicle file ",
    //     descp: "Available in English !!",
    
    // },

    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Concept of programming using c",
    //     title: "Practicle file ",
    //     descp: "Available in hindi !!",

    // },

   

    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Office automation tools",
    //     title: "Important topics ",
    //     descp: "Available in english !!",

    // },
    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Office automation tools",
    //     title: "Practicle file ",
    //     descp: "Available in English !!",
        
    // },

    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Office automation tools",
    //     title: "Practicle file ",
    //     descp: "Available in hindi !!",

    // },



    {
        branch: "Computer Science",
        sem: "2",
        sub: "Applied mathematics-II",
        title: "Syllabus",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/13jcZcl9ROcGbR-obJuVX0XXn70di6Lqj/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "2",
        sub: "Applied mathematics-II",
        title: "Previous year question paper(last year)",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/15gBiCHwE1qW8rTTGOP49OvUgTnEqVEE7/view?usp=sharing"
    },

    {
        branch: "Computer Science",
        sem: "2",
        sub: "Applied mathematics-II",
        title: "Previous year question paper(last year)",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1B0KY44N0IptiwNfKZo19DkvdXo1jg2f6/view?usp=sharing"
    },

    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Notes in hindi",
    //     descp: "Physics hindi hand written notes !",
        
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: " Notes in english",
    //     descp: "Physics english hand written notes !!",

    // },
    {
        branch: "Computer Science",
        sem: "2",
        sub: "Applied physics-II",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1mh-GhGwVr5aSnwtBn-l-CXya_ZaDGmm_/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "2",
        sub: "Applied physics-II",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/14EcILzUFr51Mf6oLeqgPfvYxgj3Wc126/view?usp=sharing"
    },
    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Important topics ",
    //     descp: "Available in english !!",

    // },
    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
        
    // },

    {
        branch: "Computer Science",
        sem: "2",
        sub: "Applied physics-II",
        title: "Practicle file ",
        descp: "Available in English !!",
        link: "https://drive.google.com/file/d/1-gBuxQycBkgpMYYkDMq36aSP4ppTtaDm/view?usp=sharing"
    },

    // {
    //     branch: "Computer Science",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Practicle file ",
    //     descp: "Available in hindi !!",
        
    // },
    

    // -----------------------------------------------------
    // Computer science - SEMESTER - 3 (Three)

    // {
    //     branch:"Computer Science",
    //     sem: "3",
    //     sub:"IWT",
    //     title:"Hand written Notes in hindi",
    //     descp: "IWT hindi hand written notes !",
        
    // },
    // {
    //     branch:"Computer Science",
    //     sem: "3",
    //     sub: "IWT",
    //     title: " Hand written Notes in english",
    //     descp: "IWT english hand written notes !!",
        
    // },
    {
        branch:"Computer Science",
        sem: "3",
        sub: "IWT",
        title:"Previous year question paper(last year) ",
        descp: "IWT Available in english !!",
        link: "https://drive.google.com/file/d/15NYxpsJ-gzTVTXIH_CY9xrdHtJrtZ7oY/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "3",
        sub: "IWT",
        title: "Previous year question paper(last year) ",
        descp: "IWT Available in hindi !!",
        link: "https://drive.google.com/file/d/10ahL_1Z2U7z4RgNZpRqPPXDWEl1_QaOX/view?usp=sharing"
    },
    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "IWT",
    //     title: "Important topics ",
    //     descp: "IWT Available in english !!",
        
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "IWT",
    //     title: "Important topics ",
    //     descp: "IWT Available in hindi !!",
        
    // },

    {
        branch: "Computer Science",
        sem: "3",
        sub: "IWT",
        title: "Practicle file ",
        descp: "IWT Available in English !!",
        link:"https://drive.google.com/file/d/1XFYxthJPRCVJsqlN5Bn5mjBwpwfpJNbO/view?usp=share_link",
        
    },

    


    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Digital electronics",
    //     title: "Hand written Notes in hindi",
    //     descp: "Digital electronics hindi hand written notes!",
        
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Digital electronics",
    //     title: " Hand written Notes in english",
    //     descp: "Digital electronics english hand written notes!",
        
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Digital electronics",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
        

    // },
    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Digital electronics",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
        

    // },
    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Digital electronics",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    {
        branch: "Computer Science",
        sem: "3",
        sub: "Digital electronics",
        title: "Important topics ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1WMcvT1iKTrZGZua4NAqDwEV25rw6vi31/view?usp=sharing",
         
    },

    {
        branch: "Computer Science",
        sem: "3",
        sub: "Digital electronics",
        title: "Practicle file ",
        descp: "Available in English !!",
        link:"https://drive.google.com/file/d/1XhdgXj6kphZKbtuJTekKSJu9y4Fewvbi/view?usp=share_link",
         
    },

    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Digital electronics",
    //     title: "Practicle file ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Data Structure using c",
    //     title: "Hand written Notes in hindi",
    //     descp: "Data Structure using c in hindi!",
         
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Data Structure using c",
    //     title: " Hand written Notes in english ",
    //     descp: "Available in english!",
         
    // },
    {
        branch: "Computer Science",
        sem: "3",
        sub: "Data Structure using c",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1vre6TuJBMlfTeZO8nIwv7uWteIMNVRNR/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "3",
        sub: "Data Structure using c",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1CAaNkRagD6Br82Js921JduyYNRpcoDay/view?usp=sharing"
    },
    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Data Structure using c",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Data Structure using c",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
        
    // },



    {
        branch: "Computer Science",
        sem: "3",
        sub: "Data Structure using c",
        title: "Practicle file ",
        descp: "Available in English !!",
        link:"https://drive.google.com/file/d/1X7zMSxdh8FkPffBYEa6wbhcuBKvQvP4H/view?usp=share_link",
         
    },

   

   

    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Data Communication and Computer Network",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Data Communication and Computer Network",
    //     title: "Practicle file ",
    //     descp: "Available in English !!",
         
    // },

    {
        branch: "Computer Science",
        sem: "3",
        sub: "Data Communication and Computer Network",
        title: "Practicle file ",
        descp: "Available in English !!",
        link:"https://drive.google.com/file/d/1X9hmZbQk8cV665rVVBerD8tR5k8Myrkm/view?usp=share_link",
         
    },
    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Data Communication and Computer Network",
    //     title: "DCCN Hand written Notes",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Data Communication and Computer Network",
    //     title: "DCCN Hand written Notes ",
    //     descp: "Available in English !!",
         
    // },

    {
        branch: "Computer Science",
        sem: "3",
        sub: "Data Communication and Computer Network",
        title: "Previous year question paper(last year) ",
        descp: "Available in English !!",
        link:"https://drive.google.com/file/d/1JEpLzPiirkGukbAaKjMJnrBwPdKtcBVR/view?usp=sharing"
    },
      {
        branch: "Computer Science",
        sem: "3",
        sub: "Data Communication and Computer Network",
        title: "Previous year question paper(last year) ",
        descp: "Available in Hindi!!",
        link:" https://drive.google.com/file/d/13xcBN6wdn6zAXB6aMPd7m1alExlQ30f5/view?usp=sharing "
    },







    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Applied mathematics-III",
    //     title: "Syllabus",
    //     descp: "Available  !!",
         
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Applied mathematics-III",
    //     title: "Previous year question paper(last year)",
    //     descp: "Available in english !!",
         
    // },

    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Applied mathematics-III",
    //     title: "Previous year question paper(last year)",
    //     descp: "Available in hindi !!",
         
    // },

    
    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Environmental studies",
    //     title: " Notes in english",
    //     descp: "ES english hand written notes !!",
         
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Environmental studies",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
  
    // {
    //     branch: "Computer Science",
    //     sem: "3",
    //     sub: "Environmental studies",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    

    {
        branch: "Computer Science",
        sem: "3",
        sub: "Environmental studies",
        title: "Practicle file ",
        descp: "Available in English !!",
        link:"https://drive.google.com/file/d/1Xcz-vAU64hqz3zVMtewZbJB8TSw5cQRz/view?usp=share_link",
         
    },

    // // -----------------------------------------------------
    // // Computer science - SEMESTER - 4 (Four)

    // {
    //     branch:"Computer Science",
    //     sem: "4",
    //     sub:"DBMS",
    //     title:"Hand written Notes in hindi",
    //     descp: "DBMS hindi hand written notes !",
         
    // },
    // {
    //     branch:"Computer Science",
    //     sem: "4",
    //     sub: "DBMS",
    //     title: " Hand written Notes in english",
    //     descp: "DBMS english hand written notes !!",
         
    // },
    {
        branch:"Computer Science",
        sem: "4",
        sub: "DBMS",
        title:"Previous year question paper(last year) ",
        descp: "DBMS Available in english !!",
        link: "https://drive.google.com/file/d/1aB5QAGu2ltSHjIVFESVThC1wDBehwmg0/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "4",
        sub: "DBMS",
        title: "Previous year question paper(last year) ",
        descp: "DBMS Available in hindi !!",
        link: "https://drive.google.com/file/d/1T-3Ok3KnZZf40HmJO-a8f10_Df4X-TRC/view?usp=sharing"
    },
    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "DBMS",
    //     title: "Important topics ",
    //     descp: "DBMS Available in english !!",
         
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "DBMS",
    //     title: "Important topics ",
    //     descp: "DBMS Available in hindi !!",
         
    // },

    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "DBMS",
    //     title: "Practicle file ",
    //     descp: "DBMS Available in English !!",
         
    // },

    


    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "Operating System",
    //     title: "Hand written Notes in hindi",
    //     descp: "Operating System hindi hand written notes!",
         
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "Operating System",
    //     title: " Hand written Notes in english",
    //     descp: "Operating System english hand written notes!",
         
    // },
    {
        branch: "Computer Science",
        sem: "4",
        sub: "Operating System",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/15NYxpsJ-gzTVTXIH_CY9xrdHtJrtZ7oY/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "4",
        sub: "Operating System",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1lPiXMxjS7zzhSM03d14XDtyuHnEzQEM2/view?usp=sharing"
    },
    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "Operating System",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "Operating System",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },

    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "Operating System",
    //     title: "Practicle file ",
    //     descp: "Available in English !!",
         
    // },

    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "Operating System",
    //     title: "Practicle file ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "E-commerce & Digital marketing",
    //     title: "Hand written Notes in hindi",
    //     descp: "E-commerce & Digital marketing in hindi!",
         
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "E-commerce & Digital marketing",
    //     title: " Hand written Notes in english ",
    //     descp: "Available in english!",
         
    // },
    {
        branch: "Computer Science",
        sem: "4",
        sub: "E-commerce & Digital marketing",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1lZUa2gmMFn1UcmMB8upTPmLgoSVKaHPz/view?usp=sharing"
    },
    {
        branch: "Computer Science",
        sem: "4",
        sub: "E-commerce & Digital marketing",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1fpBN9izvqV-BmOUD88eYdYkczhTK_s4L/view?usp=sharing"
    },
    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "E-commerce & Digital marketing",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "E-commerce & Digital marketing",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },



    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "E-commerce & Digital marketing",
    //     title: "Practicle file ",
    //     descp: "Available in English !!",
         
    // },

   

   

    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "OOP using java",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "OOP using java",
    //     title: "Practicle file ",
    //     descp: "Available in English !!",
         
    // },

    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "OOP using java",
    //     title: "Practicle file ",
    //     descp: "Available in English !!",
         
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "OOP using java",
    //     title: "OOP using java Hand written Notes",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "OOP using java",
    //     title: "OOP using java Hand written Notes ",
    //     descp: "Available in English !!",
         
    // },

    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "OOP using java",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in English !!",
         
    // },








    
    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "UHV",
    //     title: " Notes in english",
    //     descp: "ES english hand written notes !!",
         
    // },
    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "UHV",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
  
    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "UHV",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    

    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "UHV",
    //     title: "Practicle file ",
    //     descp: "Available in English !!",
         
    // },
     {
        branch: "Computer Science",
        sem: "4",
        sub: "Communication Skill-II",
        title: "Previous year question paper (last year) ",
        descp: "Available in English !!",
        link: "https://drive.google.com/file/d/1nRLOfJK4leQ1hvxu3gPqqZKAKWe6T3ax/view?usp=sharing"
    },
    // {
    //     branch: "Computer Science",
    //     sem: "4",
    //     sub: "Communication Skill-II",
    //     title: "Hand Written Notes in English ",
    //     descp: "Available in English !!",
         
    // },


  

  


    // Electrical Eng - SEMESTER -1 (ONE)
    {
        branch: " Electrical ",
        sem: "1",
        sub: "Applied physics-I",
        title: "Notes in hindi",
        descp: "Physics hindi hand written notes !",
        link: "https://drive.google.com/file/d/17u9I56JAhPDxXFFwmWOwVzfQCnXikCNe/view?usp=sharing"
    },
    // {
    //     branch: " Electrical ",
    //     sem: "1",
    //     sub: "Applied physics-I",
    //     title: " Notes in english",
    //     descp: "Physics english hand written notes !!",
         
    // },
    {
        branch: " Electrical ",
        sem: "1",
        sub: "Applied physics-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1RI6k5UR1ka2QcCJtBKZeSaTKerrOXUzh/view?usp=sharing"
    },
    {
        branch: " Electrical ",
        sem: "1",
        sub: "Applied physics-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1VLQX0fjeJx38uwIuEeRpO8505Ys_uzi-/view?usp=sharing"
    },
    // {
    //     branch: " Electrical ",
    //     sem: "1",
    //     sub: "Applied physics-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    {
        branch: " Electrical ",
        sem: "1",
        sub: "Applied physics-I",
        title: "Important topics numericals ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/1WRfH9p-5_6kaPAipZqVeFzJgs_k9rLgq/view?usp=share_link",
         
    },
    {
        branch: " Electrical ",
        sem: "1",
        sub: "Applied physics-I",
        title: "Practicle file ",
        descp: "Available in English !!",
        link: "https://drive.google.com/file/d/1EB7aNuaZ0N0he2A6ZneJqIRK3_TCnuH5/view?usp=sharing"
    },

    {
        branch: " Electrical ",
        sem: "1",
        sub: "Applied physics-I",
        title: "Practicle file ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/10jeB6jiZOh9FIe0o4Fl-Ci11gdFWZlac/view?usp=sharing"
    },



    {
        branch: " Electrical ",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Syllabus",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/13mxEj4gGKE-WwNM9nU4qPcXHBSJayLuc/view?usp=sharing"
    },
    {
        branch: "Electrical ",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Previous Year Question English",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/1hLfaeVv2GRPv1LFcDFT4hkBGCaciLo4r/view?usp=sharing"
    },
    {
        branch: "Electrical ",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Previous Year Question Hindi",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/19nGARPnrWqvGQuapxPItNlU1T8MBMuLd/view?usp=sharing"
    },


    {
        branch: " Electrical ",
        sem: "1",
        sub: "Applied chemistry",
        title: "Notes in hindi",
        descp: "Chemistry hindi hand written notes!",
        link: "https://drive.google.com/file/d/197yQ7Fm-7aUNUkErtk_2OVnr4C55WrEa/view?usp=sharing"
    },
    // {
    //     branch: " Electrical ",
    //     sem: "1",
    //     sub: "Applied chemistry",
    //     title: " Notes in english",
    //     descp: "Chemistry english hand written notes!",
         
    // },
    {
        branch: " Electrical ",
        sem: "1",
        sub: "Applied chemistry",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1U7RP-S-j1ghwoA05ve_Hf2NjbQUEPXBd/view?usp=sharing"
    },
    {
        branch: " Electrical ",
        sem: "1",
        sub: "Applied chemistry",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1kRQ0APZGFRMMPmmy2LdzgOuANAoLJQbk/view?usp=sharing"
    },
    // {
    //     branch: " Electrical ",
    //     sem: "1",
    //     sub: "Applied chemistry",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    {
        branch: " Electrical ",
        sem: "1",
        sub: "Applied chemistry",
        title: "Important topics ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/1WJye-HzI5_fZ1h5kwmCecglImIaar1f7/view?usp=sharing",
         
    },
   



    {
        branch: " Electrical ",
        sem: "1",
        sub: "Communication Skill-I",
        title: "Notes in english",
        descp: "Communication english hand written notes!",
         link:"https://drive.google.com/file/d/1WOsiVeWiO1IcBszjChFagN2tilyz9DNs/view?usp=sharing",
    },
    {
        branch: " Electrical ",
        sem: "1",
        sub: "Communication Skill-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1V0-XevYP2xI7aGDSMpsJr5Xcc-tgdfPv/view?usp=sharing "
    },
    
    // {
    //     branch: " Electrical ",
    //     sem: "1",
    //     sub: "Communication Skill-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },


    // {
    //     branch: " Electrical ",
    //     sem: "1",
    //     sub: "Engineering Drawing-I",
    //     title: "Notes in hindi",
    //     descp: "Engineering Drawing-I in hindi!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "1",
    //     sub: "Engineering Drawing-I",
    //     title: " Notes in english ",
    //     descp: "Technical drwing in english!",
         
    // },
    {
        branch: " Electrical ",
        sem: "1",
        sub: "Engineering Drawing-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1YNb7zCTPH_SD6XXS-DG39EBiAtKM62O2/view?usp=share_link",
         
    },
    {
        branch: " Electrical ",
        sem: "1",
        sub: "Engineering Drawing-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1YR3NZO4MOY1jPsTbY7PjWoDNxAo1GpMI/view?usp=share_link",
         
    },
    // {
    //     branch: " Electrical ",
    //     sem: "1",
    //     sub: "Engineering Drawing-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "1",
    //     sub: "Engineering Drawing-I",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


    {
        branch: " Electrical ",
        sem: "1",
        sub: "Basics of Information Technology",
        title: "Notes in hindi",
        descp: "Basics of Information Technology hand written notes  in hindi!",
        link: "https://drive.google.com/file/d/17vvCoBDS7Z8yPyKu1prF1UPAccM9XxB8/view?usp=sharing"
    },
    {
        branch: " Electrical ",
        sem: "1",
        sub: "Basics of Information Technology",
        title: "Notes in english",
        descp: "Basics of Information Technology hand written notes in english!",
        link:"https://drive.google.com/file/d/1WYLpeQyfavltSX152EtztTkUVIIh8Xg-/view?usp=share_link",
         
    },
    {
        branch: " Electrical ",
        sem: "1",
        sub: "Basics of Information Technology",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1WYLpeQyfavltSX152EtztTkUVIIh8Xg-/view?usp=share_link",
         
    },
    // {
    //     branch: " Electrical ",
    //     sem: "1",
    //     sub: "Basics of Information Technology",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "1",
    //     sub: "Basics of Information Technology",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },


    {
        branch: " Electrical ",
        sem: "1",
        sub: "Workshop-I",
        title: " In hindi",
        descp: "Hand written Workshop-I in hindi!",
        link: "https://drive.google.com/file/d/14Katdl6sFCLD-TZZcN69FTOGmB2kht64/view?usp=sharing"
    },
    {
        branch: " Electrica ",
        sem: "1",
        sub: "Workshop-I",
        title: "in english",
        descp: "Hand written Workshop-I in english!",
        link: "https://drive.google.com/file/d/1RI6k5UR1ka2QcCJtBKZeSaTKerrOXUzh/view?usp=sharing"
    },


    // -----------------------------------------------------
    //  Electrical Eng - SEMESTER - 2 (TWO)

    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Hand written Notes in hindi",
    //     descp: "Physics hindi hand written notes !",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: " Hand written Notes in english",
    //     descp: "Physics english hand written notes !!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Basic  Electrical Eng",
    //     title: "Hand written Notes in hindi",
    //     descp: "Chemistry hindi hand written notes!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Basic  Electrical ",
    //     title: " Hand written Notes in english",
    //     descp: "Chemistry english hand written notes!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Basic  Electrical Eng",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Basic  Electrical ",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Basic  Electrical ",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Basic  Electrical Eng",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Basics of Mechanical Eng and Civil Engineering",
    //     title: "Hand written Notes in hindi",
    //     descp: "Basics of Mechanical Eng and Civil Engineering in hindi!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Basics of Mechanical Eng and Civil Engineering",
    //     title: " Hand written Notes in english ",
    //     descp: "Technical drwing in english!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Basics of Mechanical Eng and Civil Engineering",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Basics of Mechanical Eng and Civil Engineering",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Basics of Mechanical Eng and Civil Engineering",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Basics of Mechanical Eng and Civil Engineering",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Analog Electronics",
    //     title: "Hand written Notes in hindi",
    //     descp: "Analog Electronics hand written notes  in hindi!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Analog Electronics",
    //     title: "Hand written Notes in english",
    //     descp: "Analog Electronics hand written notes in english!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Analog Electronics",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Analog Electronics",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Analog Electronics",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    {
        branch: " Electrical ",
        sem: "2",
        sub: "Applied mathematics-II",
        title: "Syllabus",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/13jcZcl9ROcGbR-obJuVX0XXn70di6Lqj/view?usp=sharing"
    },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Workshop-II",
    //     title: "in english",
    //     descp: "Hand written workshop in english!",
         
    // },
    // {
    //     branch: " Electrical ",
    //     sem: "2",
    //     sub: "Workshop-II",
    //     title: "in hindi",
    //     descp: "Hand written workshop in hindi!",
         
    // },







    // -----------------------------------------------------
    // Electrical Eng - SEMESTER - 3 (Three)

    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Electrical Instrumentation and Measurement",
    //     title: "Hand written Notes in hindi",
    //     descp: "Electrical Instrumentation and Measurement hindi hand written notes !",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Electrical Instrumentation and Measurement",
    //     title: " Hand written Notes in english",
    //     descp: "Electrical Instrumentation and Measurement english hand written notes !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Electrical Instrumentation and Measurement",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Electrical Instrumentation and Measurement",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Electrical Instrumentation and Measurement",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Electrical Instrumentation and Measurement",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Electrical and Electronics Engineering Materials",
    //     title: "Hand written Notes in hindi",
    //     descp: "Chemistry hindi hand written notes!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Electrical and Electronics Engineering Materials",
    //     title: " Hand written Notes in english",
    //     descp: "Chemistry english hand written notes!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Electrical and Electronics Engineering Materials",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Electrical and Electronics Engineering Materials",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Electrical and Electronics Engineering Materials",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Electrical and Electronics Engineering Materials",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Digital Electronics",
    //     title: "Hand written Notes in hindi",
    //     descp: "Digital Electronics in hindi!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Digital Electronics",
    //     title: " Hand written Notes in english ",
    //     descp: "Technical drwing in english!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Digital Electronics",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Digital Electronics",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Digital Electronics",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Digital Electronics",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Electrical Machine-I",
    //     title: "Hand written Notes in hindi",
    //     descp: "Electrical Machine-I hand written notes  in hindi!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Electrical Machine-I",
    //     title: "Hand written Notes in english",
    //     descp: "Electrical Machine-I hand written notes in english!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Electrical Machine-I",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "3",
    //     sub: "Electrical Machine-I",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electric",
    //     sem: "3",
    //     sub: "Electrical Machine-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electric",
    //     sem: "3",
    //     sub: "Applied mathematics-III",
    //     title: "Syllabus",
    //     descp: "Available  !!",
         
    // },
    // {
    //     branch: "Electric",
    //     sem: "3",
    //     sub: "Environmental Studies",
    //     title: "in english",
    //     descp: "Hand written ES in english!",
         
    // },
    // {
    //     branch: "Electric",
    //     sem: "3",
    //     sub: "Environmental Studies",
    //     title: "in hindi",
    //     descp: "Hand written ES in hindi!",
         
    // },





     // -----------------------------------------------------
    // Electrical Eng - SEMESTER - 4 (Four)

    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Industrial Electronics and Control",
    //     title: "Hand written Notes in hindi",
    //     descp: "Industrial Electronics and Control hindi hand written notes !",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Industrial Electronics and Control",
    //     title: " Hand written Notes in english",
    //     descp: "Industrial Electronics and Control english hand written notes !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Industrial Electronics and Control",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Industrial Electronics and Control",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Industrial Electronics and Control",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Industrial Electronics and Control",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Power Plant Engineering",
    //     title: "Hand written Notes in hindi",
    //     descp: "Chemistry hindi hand written notes!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Power Plant Engineering",
    //     title: " Hand written Notes in english",
    //     descp: "Chemistry english hand written notes!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Power Plant Engineering",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Power Plant Engineering",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Power Plant Engineering",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Power Plant Engineering",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


  
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Communication Skill-II",
    //     title: " Hand written Notes in english ",
    //     descp: "Technical drwing in english!",
         
    // },
    {
        branch: "Electrical ",
        sem: "4",
        sub: "Communication Skill-II",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1nRLOfJK4leQ1hvxu3gPqqZKAKWe6T3ax/view?usp=sharing"
    },
    
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Communication Skill-II",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
   


    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Electrical Design, Drawing and Estimating-I",
    //     title: "Hand written Notes in hindi",
    //     descp: "Electrical Design, Drawing and Estimating-I hand written notes  in hindi!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Electrical Design, Drawing and Estimating-I",
    //     title: "Hand written Notes in english",
    //     descp: "Electrical Design, Drawing and Estimating-I hand written notes in english!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Electrical Design, Drawing and Estimating-I",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Electrical Design, Drawing and Estimating-I",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Electrical Design, Drawing and Estimating-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Universal Human Values",
    //     title: "in english",
    //     descp: "Hand written ES in english!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Universal Human Values",
    //     title: "in hindi",
    //     descp: "Hand written ES in hindi!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Energy Conservation",
    //     title: "Hand written Notes in hindi",
    //     descp: "Energy Conservation hand written notes  in hindi!",
         
    // },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Energy Conservation",
    //     title: "Hand written Notes in english",
    //     descp: "Energy Conservation hand written notes in english!",
         
    // },
    {
        branch: "Electrical ",
        sem: "4",
        sub: "Energy Conservation",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1-uqqT2vrK7JyDU3ctK_-8zcUMnxJWxX0/view?usp=sharing"
    },
    {
        branch: "Electrical ",
        sem: "4",
        sub: "Energy Conservation",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1Ssz8u9mGiSKrMuaQBXQsfVoa8zjyvO_B/view?usp=sharing"
    },
    // {
    //     branch: "Electrical ",
    //     sem: "4",
    //     sub: "Energy Conservation",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },


















    // electronics - SEMESTER -1 (ONE)
    {
        branch: "Electronics",
        sem: "1",
        sub: "Applied physics-I",
        title: "Notes in hindi",
        descp: "Physics hindi hand written notes !",
        link: "https://drive.google.com/file/d/17u9I56JAhPDxXFFwmWOwVzfQCnXikCNe/view?usp=sharing"
    },
    // {
    //     branch: "Electronics",
    //     sem: "1",
    //     sub: "Applied physics-I",
    //     title: " Notes in english",
    //     descp: "Physics english hand written notes !!",
        
    // },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Applied physics-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1RI6k5UR1ka2QcCJtBKZeSaTKerrOXUzh/view?usp=sharing"
    },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Applied physics-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1VLQX0fjeJx38uwIuEeRpO8505Ys_uzi-/view?usp=sharing"
    },
    // {
    //     branch: "Electronics",
    //     sem: "1",
    //     sub: "Applied physics-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Applied physics-I",
        title: "Important topics numericals ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/1WRfH9p-5_6kaPAipZqVeFzJgs_k9rLgq/view?usp=share_link",
         
    },

    {
        branch: "Electronics",
        sem: "1",
        sub: "Applied physics-I",
        title: "Practicle file ",
        descp: "Available in English !!",
        link: "https://drive.google.com/file/d/1EB7aNuaZ0N0he2A6ZneJqIRK3_TCnuH5/view?usp=sharing"
    },

    {
        branch: "Electronics",
        sem: "1",
        sub: "Applied physics-I",
        title: "Practicle file ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/10jeB6jiZOh9FIe0o4Fl-Ci11gdFWZlac/view?usp=sharing"
    },

    {
        branch: "Electronics",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Syllabus",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/13mxEj4gGKE-WwNM9nU4qPcXHBSJayLuc/view?usp=sharing"
    },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Previous Year Question English",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/1hLfaeVv2GRPv1LFcDFT4hkBGCaciLo4r/view?usp=sharing"
    },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Previous Year Question Hindi",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/19nGARPnrWqvGQuapxPItNlU1T8MBMuLd/view?usp=sharing"
    },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Applied chemistry",
        title: "Notes in hindi",
        descp: "Chemistry hindi hand written notes!",
        link: "https://drive.google.com/file/d/197yQ7Fm-7aUNUkErtk_2OVnr4C55WrEa/view?usp=sharing"
    },
    // {
    //     branch: "Electronics",
    //     sem: "1",
    //     sub: "Applied chemistry",
    //     title: " Notes in english",
    //     descp: "Chemistry english hand written notes!",
         
    // },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Applied chemistry",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1U7RP-S-j1ghwoA05ve_Hf2NjbQUEPXBd/view?usp=sharing"
    },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Applied chemistry",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1kRQ0APZGFRMMPmmy2LdzgOuANAoLJQbk/view?usp=sharing"
    },
    // {
    //     branch: "Electronics",
    //     sem: "1",
    //     sub: "Applied chemistry",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Applied chemistry",
        title: "Important topics ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/1WJye-HzI5_fZ1h5kwmCecglImIaar1f7/view?usp=sharing"
         
    },
    
    {
        branch: "Electronics",
        sem: "1",
        sub: "Communication Skill-I",
        title: "Notes in english",
        descp: "Communication english hand written notes!",
        link:"https://drive.google.com/file/d/1WOsiVeWiO1IcBszjChFagN2tilyz9DNs/view?usp=sharing",
         
    },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Communication Skill-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1V0-XevYP2xI7aGDSMpsJr5Xcc-tgdfPv/view?usp=sharing"
    },

    // {
    //     branch: "Electronics",
    //     sem: "1",
    //     sub: "Communication Skill-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Communication Skill-I",
        title: "Important topics ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/1WOsiVeWiO1IcBszjChFagN2tilyz9DNs/view?usp=share_link",
         
    },
    // {
    //     branch: "Electronics",
    //     sem: "1",
    //     sub: "Engineering Drawing-I",
    //     title: "Notes in hindi",
    //     descp: " Engineering Drawing in hindi!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "1",
    //     sub: "Engineering Drawing-I",
    //     title: " Notes in english ",
    //     descp: "Engineering Drawing in english!",
         
    // },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Engineering Drawing-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1mDN6at540cjtZnwhUUjFBWueI2a3uVfV/view?usp=sharing"
    },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Engineering Drawing-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1Co9WTIont896qEJZqMUkPk7HtXIiejnA/view?usp=sharing"
    },
    // {
    //     branch: "Electronics",
    //     sem: "1",
    //     sub: "Engineering Drawing-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "1",
    //     sub: "Engineering Drawing-I",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Basics of Information Technology",
        title: "Notes in hindi",
        descp: "Basics of Information Technology hand written notes  in hindi!",
        link: "https://drive.google.com/file/d/17vvCoBDS7Z8yPyKu1prF1UPAccM9XxB8/view?usp=sharing"
    },
    // {
    //     branch: "Electronics",
    //     sem: "1",
    //     sub: "Basics of Information Technology",
    //     title: "Notes in english",
    //     descp: "Basics of Information Technology hand written notes in english!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "1",
    //     sub: "Basics of Information Technology",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "1",
    //     sub: "Basics of Information Technology",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
    //     link: "    "
    // },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Basics of Information Technology",
        title: "Important topics ",
        descp: "Available in english !!",
        link:"https://drive.google.com/file/d/1WYLpeQyfavltSX152EtztTkUVIIh8Xg-/view?usp=share_link",
         
    },
    // {
    //     branch: "Electronics",
    //     sem: "1",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "1",
    //     title: "Engineering Drawing-I ",
    //     descp: "file Available in hindi !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "1",
    //     title: "Engineering Drawing-I ",
    //     descp: "file Available in english !!",
         
    // },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Workshop",
        title: " In hindi",
        descp: "Hand written workshop in hindi!",
        link: "https://drive.google.com/file/d/14Katdl6sFCLD-TZZcN69FTOGmB2kht64/view?usp=sharing"
    },
    {
        branch: "Electronics",
        sem: "1",
        sub: "Workshop",
        title: "in english",
        descp: "Hand written workshop in english!",
        link: "https://drive.google.com/file/d/1-hwPUqPFP0Of0kNGTrlw7t3MhwpZ83Ks/view?usp=sharing"
    },
    // -----------------------------------------------------
    // Electronics - SEMESTER - 2 (TWO)

    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Hand written Notes in hindi",
    //     descp: "Physics hindi hand written notes !",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: " Hand written Notes in english",
    //     descp: "Physics english hand written notes !!",
         
    // },
    {
        branch: "Electronics",
        sem: "2",
        sub: "Applied physics-II",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1xmaWS-txheP3ml1wnf1dSLaIiEfoT6mP/view?usp=sharing"
    },
    {
        branch: "Electronics",
        sem: "2",
        sub: "Applied physics-II",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1Gey2jJejUCMPc5qShXsOSkwOy4q9zeIK/view?usp=sharing"
    },
    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: "Basic  Electrical Eng",
    //     title: "Hand written Notes in hindi",
    //     descp: "Basic  Electrical EngE hindi hand written notes!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: "Basic  Electrical Eng",
    //     title: " Hand written Notes in english",
    //     descp: "Basic  Electrical EngE english hand written notes!",
         
    // },
    {
        branch: "Electronics",
        sem: "2",
        sub: "Basic  Electrical Eng",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1D7VknypvmUTj1pBm2zj1-asBQLr4MKrI/view?usp=sharing"
    },
    {
        branch: "Electronics",
        sem: "2",
        sub: "Basic  Electrical Eng",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1BsyYB0KFPLOS8NMLNzA3B-IB2FjTJTfF/view?usp=sharing"
    },
    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: "Basic  Electrical Eng",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: "Basic  Electrical Eng",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: "Electronics Component and Device",
    //     title: "Hand written Notes in hindi",
    //     descp: "Electronics Component and Device in hindi!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: "Electronics Component and Device",
    //     title: " Hand written Notes in english ",
    //     descp: "Technical drwing in english!",
         
    // },
    {
        branch: "Electronics",
        sem: "2",
        sub: "Electronics Component and Device",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/15eybm1qYi-5Qe5ob22KrGheUe8TWalh7/view?usp=sharing"
    },
    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: "Electronics Component and Device",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: "Electronics Component and Device",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: "Electronics Component and Device",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },

    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: " Electrical Eng and Electronics Workshop",
    //     title: "Hand written Notes in hindi",
    //     descp: " Electrical Eng and Electronics Workshop hand written notes  in hindi!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: " Electrical Eng and Electronics Workshop",
    //     title: "Hand written Notes in english",
    //     descp: " Electrical Eng and Electronics Workshop hand written notes in english!",
         
    // },

    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: " Electrical Eng and Electronics Workshop",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    {
        branch: "Electronics",
        sem: "2",
        sub: "Applied mathematics-II",
        title: "Syllabus",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/13jcZcl9ROcGbR-obJuVX0XXn70di6Lqj/view?usp=sharing"
    },
    {
        branch: "Electronics",
        sem: "2",
        sub: "Applied mathematics-II",
        title: "Previous year question paper(last year)",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/15gBiCHwE1qW8rTTGOP49OvUgTnEqVEE7/view?usp=sharing"
    },

    {
        branch: "Electronics",
        sem: "2",
        sub: "Applied mathematics-II",
        title: "Previous year question paper(last year)",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1B0KY44N0IptiwNfKZo19DkvdXo1jg2f6/view?usp=sharing"
    },
    // {
    //     branch: "Electronics",
    //     sem: "2",
    //     sub: "Workshop-II",
    //     title: " In hindi",
    //     descp: "Hand written workshop in hindi!",
         
    // },
    {
        branch: "Electronics",
        sem: "2",
        sub: "Workshop-II",
        title: "in english",
        descp: "Hand written workshop in english!",
        link: "https://drive.google.com/file/d/1-hwPUqPFP0Of0kNGTrlw7t3MhwpZ83Ks/view?usp=sharing"
    },




      // -----------------------------------------------------
    // Electronics engineering - SEMESTER - 3 (Three)

    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical and Electronics Instrumentation Measurement",
    //     title: "Hand written Notes in hindi",
    //     descp: "Electrical and Electronics Instrumentation Measurement hindi hand written notes !",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical and Electronics Instrumentation Measurement",
    //     title: " Hand written Notes in english",
    //     descp: "Electrical and Electronics Instrumentation Measurement english hand written notes !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical and Electronics Instrumentation Measurement",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical and Electronics Instrumentation Measurement",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical and Electronics Instrumentation Measurement",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical and Electronics Instrumentation Measurement",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical and Electronics Engineering Materials",
    //     title: "Hand written Notes in hindi",
    //     descp: "Chemistry hindi hand written notes!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical and Electronics Engineering Materials",
    //     title: " Hand written Notes in english",
    //     descp: "Chemistry english hand written notes!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical and Electronics Engineering Materials",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical and Electronics Engineering Materials",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical and Electronics Engineering Materials",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical and Electronics Engineering Materials",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Digital Electronics",
    //     title: "Hand written Notes in hindi",
    //     descp: "Digital Electronics in hindi!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Digital Electronics",
    //     title: " Hand written Notes in english ",
    //     descp: "Technical drwing in english!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Digital Electronics",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Digital Electronics",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Digital Electronics",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Digital Electronics",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical Machine-I",
    //     title: "Hand written Notes in hindi",
    //     descp: "Electrical Machine-I hand written notes  in hindi!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical Machine-I",
    //     title: "Hand written Notes in english",
    //     descp: "Electrical Machine-I hand written notes in english!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical Machine-I",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical Machine-I",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Electrical Machine-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Applied mathematics-III",
    //     title: "Syllabus",
    //     descp: "Available  !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Environmental Studies",
    //     title: "in english",
    //     descp: "Hand written ES in english!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "3",
    //     sub: "Environmental Studies",
    //     title: "in hindi",
    //     descp: "Hand written ES in hindi!",
         
    // },
    {
        branch: "Electronics",
        sem: "3",
        sub: "Environmental studies",
        title: "Practicle file ",
        descp: "Available in English !!",
        link:"https://drive.google.com/file/d/1Xcz-vAU64hqz3zVMtewZbJB8TSw5cQRz/view?usp=share_link",
         
    },







    // -----------------------------------------------------
    // Electronics engineering - SEMESTER - 4 (Four)

    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Industrial Electronics and Control",
    //     title: "Hand written Notes in hindi",
    //     descp: "Industrial Electronics and Control hindi hand written notes !",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Industrial Electronics and Control",
    //     title: " Hand written Notes in english",
    //     descp: "Industrial Electronics and Control english hand written notes !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Industrial Electronics and Control",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Industrial Electronics and Control",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Industrial Electronics and Control",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Industrial Electronics and Control",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Network Filters and Transmission Lines",
    //     title: "Hand written Notes in hindi",
    //     descp: "Chemistry hindi hand written notes!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Network Filters and Transmission Lines",
    //     title: " Hand written Notes in english",
    //     descp: "Chemistry english hand written notes!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Network Filters and Transmission Lines",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Network Filters and Transmission Lines",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Network Filters and Transmission Lines",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Network Filters and Transmission Lines",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


  
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Communication Skill-II",
    //     title: " Hand written Notes in english ",
    //     descp: "Technical drwing in english!",
         
    // },
    {
        branch: "Electronics",
        sem: "4",
        sub: "Communication Skill-II",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1nRLOfJK4leQ1hvxu3gPqqZKAKWe6T3ax/view?usp=sharing"
    },
    
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Communication Skill-II",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
   


    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Electrical Design, Drawing and Estimating-I",
    //     title: "Hand written Notes in hindi",
    //     descp: "Electrical Design, Drawing and Estimating-I hand written notes  in hindi!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Electrical Design, Drawing and Estimating-I",
    //     title: "Hand written Notes in english",
    //     descp: "Electrical Design, Drawing and Estimating-I hand written notes in english!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Electrical Design, Drawing and Estimating-I",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Electrical Design, Drawing and Estimating-I",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Electrical Design, Drawing and Estimating-I",
    //     title: "Important topics  ",
    //     descp: "Available in english !!",
         
    // },

    //    {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Transmission and Distribution of Electrical Power",
    //     title: "Hand written Notes in hindi",
    //     descp: "Energy Conservation hand written notes  in hindi!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Transmission and Distribution of Electrical Power",
    //     title: "Hand written Notes in english",
    //     descp: "Energy Conservation hand written notes in english!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Transmission and Distribution of Electrical Power",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Transmission and Distribution of Electrical Power",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Transmission and Distribution of Electrical Power",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    
   
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Energy Conservation",
    //     title: "Hand written Notes in hindi",
    //     descp: "Energy Conservation hand written notes  in hindi!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Energy Conservation",
    //     title: "Hand written Notes in english",
    //     descp: "Energy Conservation hand written notes in english!",
         
    // },
    {
        branch: "Electronics",
        sem: "4",
        sub: "Energy Conservation",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1-uqqT2vrK7JyDU3ctK_-8zcUMnxJWxX0/view?usp=sharing"
    },
    {
        branch: "Electronics",
        sem: "4",
        sub: "Energy Conservation",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1Ssz8u9mGiSKrMuaQBXQsfVoa8zjyvO_B/view?usp=sharing"
    },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Energy Conservation",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },

    //    {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Principle Of Communication Engineering",
    //     title: "Hand written Notes in hindi",
    //     descp: "Energy Conservation hand written notes  in hindi!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Principle Of Communication Engineering",
    //     title: "Hand written Notes in english",
    //     descp: "Energy Conservation hand written notes in english!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Principle Of Communication Engineering",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Principle Of Communication Engineering",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Electronics",
    //     sem: "4",
    //     sub: "Principle Of Communication Engineering",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },


















    //Information and Technology - SEMESTER -1 (ONE)

    {
        branch: "Information Technology",
        sem: "1",
        sub: "Applied physics-I",
        title: "Notes in hindi",
        descp: "Physics hindi hand written notes !",
        link: "https://drive.google.com/file/d/17u9I56JAhPDxXFFwmWOwVzfQCnXikCNe/view?usp=sharing"
    },
    // {
    //     branch: "Information Technology",
    //     sem: "1",
    //     sub: "Applied physics-I",
    //     title: " Notes in english",
    //     descp: "Physics english hand written notes !!",
         
    // },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "Applied physics-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1RI6k5UR1ka2QcCJtBKZeSaTKerrOXUzh/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "Applied physics-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1VLQX0fjeJx38uwIuEeRpO8505Ys_uzi-/view?usp=sharing"
    },
    // {
    //     branch: "Information Technology",
    //     sem: "1",
    //     sub: "Applied physics-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "Applied physics-I",
        title: "Important topics numericals",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/1WRfH9p-5_6kaPAipZqVeFzJgs_k9rLgq/view?usp=share_link",
         
    },

     {
        branch: "Information Technology",
        sem: "1",
        sub: "Applied physics-I",
        title: "Practicle file ",
        descp: "Available in English !!",
        link: "https://drive.google.com/file/d/1EB7aNuaZ0N0he2A6ZneJqIRK3_TCnuH5/view?usp=sharing"
    },

    {
        branch: "Information Technology",
        sem: "1",
        sub: "Applied physics-I",
        title: "Practicle file ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/10jeB6jiZOh9FIe0o4Fl-Ci11gdFWZlac/view?usp=sharing"
    },












    {
        branch: "Information Technology",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Syllabus",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/13mxEj4gGKE-WwNM9nU4qPcXHBSJayLuc/view?usp=sharing "
    },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Previous Year Question English",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/1hLfaeVv2GRPv1LFcDFT4hkBGCaciLo4r/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Previous Year Question Hindi",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/19nGARPnrWqvGQuapxPItNlU1T8MBMuLd/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "Applied chemistry",
        title: "Notes in hindi",
        descp: "Chemistry hindi hand written notes!",
        link: "https://drive.google.com/file/d/197yQ7Fm-7aUNUkErtk_2OVnr4C55WrEa/view?usp=sharing"
    },
    // {
    //     branch: "Information Technology",
    //     sem: "1",
    //     sub: "Applied chemistry",
    //     title: " Notes in english",
    //     descp: "Chemistry english hand written notes!",
         
    // },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "Applied chemistry",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1U7RP-S-j1ghwoA05ve_Hf2NjbQUEPXBd/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "Applied chemistry",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1kRQ0APZGFRMMPmmy2LdzgOuANAoLJQbk/view?usp=sharing"
    },
    // {
    //     branch: "Information Technology",
    //     sem: "1",
    //     sub: "Applied chemistry",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "Applied chemistry",
        title: "Important topics ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/1WJye-HzI5_fZ1h5kwmCecglImIaar1f7/view?usp=sharing",
         
    },




    {
        branch: "Information Technology",
        sem: "1",
        sub: "Applied chemistry",
        title: "Practicle file ",
        descp: "Available in English !!",
        link: "https://drive.google.com/file/d/1-v1VAqErxYIzoTXAUrzo5JeakaG1JCUB/view?usp=sharing"
    },

    // {
    //     branch: "Information Technology",
    //     sem: "1",
    //     sub: "Applied chemistry",
    //     title: "Practicle file ",
    //     descp: "Available in hindi !!",
         
    // },


















    {
        branch: "Information Technology",
        sem: "1",
        sub: "Communication Skill-I",
        title: "Notes in english",
        descp: "Communication english hand written notes!",
        link:"https://drive.google.com/file/d/1WOsiVeWiO1IcBszjChFagN2tilyz9DNs/view?usp=sharing",
         
    },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "Communication Skill-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1V0-XevYP2xI7aGDSMpsJr5Xcc-tgdfPv/view?usp=sharing"
    },

    // {
    //     branch: "Information Technology",
    //     sem: "1",
    //     sub: "Communication Skill-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    
    // {
    //     branch: "Information Technology",
    //     sem: "1",
    //     sub: "Technical drawing",
    //     title: "Notes in hindi",
    //     descp: "Technical drawing in hindi!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "1",
    //     sub: "technical drawing",
    //     title: " Notes in english ",
    //     descp: "Technical drwing in english!",
         
    // },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "Technical drawing",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1mDN6at540cjtZnwhUUjFBWueI2a3uVfV/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "Technical drawing",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1Co9WTIont896qEJZqMUkPk7HtXIiejnA/view?usp=sharing"
    },
    // {
    //     branch: "Information Technology",
    //     sem: "1",
    //     sub: "Technical drawing",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "1",
    //     sub: "Technical drawing",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "FCIT",
        title: "Notes in hindi",
        descp: "FCIT hand written notes  in hindi!",
        link: "https://drive.google.com/file/d/17vvCoBDS7Z8yPyKu1prF1UPAccM9XxB8/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "FCIT",
        title: "Notes in english",
        descp: "FCIT hand written notes in english!",
        link: "https://drive.google.com/file/d/1el00azf7P-Ef1dzbzfimCBxbDCB-hdui/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "FCIT",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1oO4Q-5i9vs5eybfcbGVJBVougHd6Unwg/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "FCIT",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1oZ7eCmCYTNtgfYnoDzqQmRrtnq3m0LMP/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "FCIT",
        title: "Important topics ",
        descp: "Available in english !!",
        link:"https://drive.google.com/file/d/1WYLpeQyfavltSX152EtztTkUVIIh8Xg-/view?usp=share_link",
         
    },
    // {
    //     branch: "Information Technology",
    //     sem: "Applied chemistry",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "Workshop",
        title: " In hindi",
        descp: "Hand written workshop in hindi!",
        link: "https://drive.google.com/file/d/14Katdl6sFCLD-TZZcN69FTOGmB2kht64/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "1",
        sub: "Workshop",
        title: "in english",
        descp: "Hand written workshop in english!",
        link: "https://drive.google.com/file/d/1-hwPUqPFP0Of0kNGTrlw7t3MhwpZ83Ks/view?usp=sharing"
    },









    {
        branch: "Information Technology",
        sem: "1",
        sub: "Technical Drawing",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1YARpBtApCYVvfaurk3u-U51p0pFsGaVY/view?usp=share_link"
    },

    {
        branch: "Information Technology",
        sem: "1",
        sub: "Technical Drawing",
        title: "Previous year question paper(last year) ",
        descp: "Available in Hindi !!",
        link: "https://drive.google.com/file/d/1YDFuJ1iZOEEZEcpOCNbdAdI4E8VXfgRX/view?usp=share_link"
    },
    // -----------------------------------------------------
    //Information and Technology - SEMESTER -2 (TWO)

    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Multimedia & Animation",
    //     title: "Hand written Notes in hindi",
    //     descp: "Physics hindi hand written notes !",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Multimedia & Animation",
    //     title: " Hand written Notes in english",
    //     descp: "Physics english hand written notes !!",
         
    // },
    {
        branch: "Information Technology",
        sem: "2",
        sub: "Multimedia & Animation",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1xmaWS-txheP3ml1wnf1dSLaIiEfoT6mP/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "2",
        sub: "Multimedia & Animation",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1Gey2jJejUCMPc5qShXsOSkwOy4q9zeIK/view?usp=sharing"
    },
    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Multimedia & Animation",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Multimedia & Animation",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },

    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Multimedia & Animation",
    //     title: "Practicle file ",
    //     descp: "Available in English !!",
         
    // },

    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Multimedia & Animation",
    //     title: "Practicle file ",
    //     descp: "Available in hindi !!",
         
    // },




















    {
        branch: "Information Technology",
        sem: "2",
        sub: "BEE",
        title: "Hand written Notes in hindi",
        descp: "BEEE hindi hand written notes!",
        link: "https://drive.google.com/file/d/14-n_YokN58EOoXxyzE04yuxrJ7OHuX_N/view?usp=sharing"
    },
    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "BEE",
    //     title: " Hand written Notes in english",
    //     descp: "BEEE english hand written notes!",
         
    // },
    {
        branch: "Information Technology",
        sem: "2",
        sub: "BEE",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1D7VknypvmUTj1pBm2zj1-asBQLr4MKrI/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "2",
        sub: "BEE",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1BsyYB0KFPLOS8NMLNzA3B-IB2FjTJTfF/view?usp=sharing"
    },
    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "BEE",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "BEE",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },

    {
        branch: "Information Technology",
        sem: "2",
        sub: "BEE",
        title: "Practicle file ",
        descp: "Available in English !!",
        link: "https://drive.google.com/file/d/1-hp1Dc-9hBV1ULsj-Vv-XSQ4W5G-Ee1o/view?usp=sharing"
    },

    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "BEE",
    //     title: "Practicle file ",
    //     descp: "Available in hindi !!",
         
    // },


    {
        branch: "Information Technology",
        sem: "2",
        sub: "Concept of programming using c",
        title: "Hand written Notes in hindi",
        descp: "Concept of programming using c in hindi!",
        link: "https://drive.google.com/file/d/14-R21eJpqmLCK31hYM5F9G0m5IbRlF7c/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "2",
        sub: "Concept of programming using c",
        title: " Hand written Notes in english ",
        descp: "Available in english!",
        link: "https://drive.google.com/file/d/15Cq4TqF2LHirxCGrgnOQ4hdfynoEp0Cd/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "2",
        sub: "Concept of programming using c",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/15eybm1qYi-5Qe5ob22KrGheUe8TWalh7/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "2",
        sub: "Concept of programming using c",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1dhRG2KUbfjufuy62FHHGtfHtf7fIbt7P/view?usp=sharing"
    },
    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Concept of programming using c",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Concept of programming using c",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },



    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Concept of programming using c",
    //     title: "Practicle file ",
    //     descp: "Available in English !!",
         
    // },

    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Concept of programming using c",
    //     title: "Practicle file ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Office automation tools",
    //     title: "Hand written Notes in hindi",
    //     descp: "Office automation tools hand written notes  in hindi!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Office automation tools",
    //     title: "Hand written Notes in english",
    //     descp: "Office automation tools hand written notes in english!",
         
    // },

    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Office automation tools",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Office automation tools",
    //     title: "Practicle file ",
    //     descp: "Available in English !!",
         
    // },

    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Office automation tools",
    //     title: "Practicle file ",
    //     descp: "Available in hindi !!",
         
    // },



    {
        branch: "Information Technology",
        sem: "2",
        sub: "Applied mathematics-II",
        title: "Syllabus",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/13jcZcl9ROcGbR-obJuVX0XXn70di6Lqj/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "2",
        sub: "Applied mathematics-II",
        title: "Previous year question paper(last year)",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/15gBiCHwE1qW8rTTGOP49OvUgTnEqVEE7/view?usp=sharing"
    },

    {
        branch: "Information Technology",
        sem: "2",
        sub: "Applied mathematics-II",
        title: "Previous year question paper(last year)",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1B0KY44N0IptiwNfKZo19DkvdXo1jg2f6/view?usp=sharing"
    },

    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Notes in hindi",
    //     descp: "Physics hindi hand written notes !",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: " Notes in english",
    //     descp: "Physics english hand written notes !!",
         
    // },
    {
        branch: "Information Technology",
        sem: "2",
        sub: "Applied physics-II",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1mh-GhGwVr5aSnwtBn-l-CXya_ZaDGmm_/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "2",
        sub: "Applied physics-II",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/14EcILzUFr51Mf6oLeqgPfvYxgj3Wc126/view?usp=sharing"
    },
    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },

    {
        branch: "Information Technology",
        sem: "2",
        sub: "Applied physics-II",
        title: "Practicle file ",
        descp: "Available in English !!",
        link: "https://drive.google.com/file/d/1-gBuxQycBkgpMYYkDMq36aSP4ppTtaDm/view?usp=sharing"
    },

    // {
    //     branch: "Information Technology",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Practicle file ",
    //     descp: "Available in hindi !!",
         
    // },




    // -----------------------------------------------------
    // Information Technology - SEMESTER - 3 (Three)

    // {
    //     branch:"Information Technology",
    //     sem: "3",
    //     sub:"IWT",
    //     title:"Hand written Notes in hindi",
    //     descp: "IWT hindi hand written notes !",
         
    // },
    // {
    //     branch:"Information Technology",
    //     sem: "3",
    //     sub: "IWT",
    //     title: " Hand written Notes in english",
    //     descp: "IWT english hand written notes !!",
         
    // },
    {
        branch:"Information Technology",
        sem: "3",
        sub: "IWT",
        title:"Previous year question paper(last year) ",
        descp: "IWT Available in english !!",
        link: "https://drive.google.com/file/d/15NYxpsJ-gzTVTXIH_CY9xrdHtJrtZ7oY/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "3",
        sub: "IWT",
        title: "Previous year question paper(last year) ",
        descp: "IWT Available in hindi !!",
        link: "https://drive.google.com/file/d/10ahL_1Z2U7z4RgNZpRqPPXDWEl1_QaOX/view?usp=sharing"
    },
    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "IWT",
    //     title: "Important topics ",
    //     descp: "IWT Available in english !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "IWT",
    //     title: "Important topics ",
    //     descp: "IWT Available in hindi !!",
         
    // },

    {
        branch: "Information Technology",
        sem: "3",
        sub: "IWT",
        title: "Practicle file ",
        descp: "IWT Available in English !!",
        link:"https://drive.google.com/file/d/1XFYxthJPRCVJsqlN5Bn5mjBwpwfpJNbO/view?usp=share_link",
         
    },

    


    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "CHM",
    //     title: "Hand written Notes in hindi",
    //     descp: "Digital electronics hindi hand written notes!",
         
    // },
    {
        branch: "Information Technology",
        sem: "3",
        sub: "Digital electronics",
        title: "Practicle file ",
        descp: "Available in English !!",
        link:"https://drive.google.com/file/d/1XhdgXj6kphZKbtuJTekKSJu9y4Fewvbi/view?usp=share_link",
         
    },
    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "CHM",
    //     title: " Hand written Notes in english",
    //     descp: "Digital electronics english hand written notes!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "CHM",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "CHM",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "CHM",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "CHM",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },

    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "CHM",
    //     title: "Practicle file ",
    //     descp: "Available in English !!",
         
    // },

    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "CHM",
    //     title: "Practicle file ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "Data Structure using c",
    //     title: "Hand written Notes in hindi",
    //     descp: "Data Structure using c in hindi!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "Data Structure using c",
    //     title: " Hand written Notes in english ",
    //     descp: "Available in english!",
         
    // },
   {
        branch: "Information Technology",
        sem: "3",
        sub: "Data Structure using c",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1vre6TuJBMlfTeZO8nIwv7uWteIMNVRNR/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "3",
        sub: "Data Structure using c",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1CAaNkRagD6Br82Js921JduyYNRpcoDay/view?usp=sharing"
    },
    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "Data Structure using c",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "Data Structure using c",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },



    {
        branch: "Information Technology",
        sem: "3",
        sub: "Data Structure using c",
        title: "Practicle file ",
        descp: "Available in English !!",
        link:"https://drive.google.com/file/d/1X7zMSxdh8FkPffBYEa6wbhcuBKvQvP4H/view?usp=share_link",
    },

   

   

    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "Data Communication and Computer Network",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    {
        branch: "Information Technology",
        sem: "3",
        sub: "Data Communication and Computer Network",
        title: "Practicle file ",
        descp: "Available in English !!",
        link: "https://drive.google.com/file/d/1X9hmZbQk8cV665rVVBerD8tR5k8Myrkm/view?usp=share_link",
         
    },

    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "Data Communication and Computer Network",
    //     title: "Practicle file ",
    //     descp: "Available in English !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "Data Communication and Computer Network",
    //     title: "DCCN Hand written Notes",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "Data Communication and Computer Network",
    //     title: "DCCN Hand written Notes ",
    //     descp: "Available in English !!",
         
    // },
    {
        branch: "Information Technology",
        sem: "3",
        sub: "Data Communication and Computer Network",
        title: "Practicle file ",
        descp: "Available in English !!",
        link: "https://drive.google.com/file/d/1X9hmZbQk8cV665rVVBerD8tR5k8Myrkm/view?usp=share_link",
         
    },

    {
        branch: "Information Technology",
        sem: "3",
        sub: "Data Communication and Computer Network",
        title: "Previous year question paper(last year) ",
        descp: "Available in English !!",
        link:"https://drive.google.com/file/d/1JEpLzPiirkGukbAaKjMJnrBwPdKtcBVR/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "3",
        sub: "Data Communication and Computer Network",
        title: "Previous year question paper(last year) ",
        descp: "Available in Hindi!!",
        link:"https://drive.google.com/file/d/13xcBN6wdn6zAXB6aMPd7m1alExlQ30f5/view?usp=sharing"
    },






    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "Applied mathematics-III",
    //     title: "Syllabus",
    //     descp: "Available  !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "Applied mathematics-III",
    //     title: "Previous year question paper(last year)",
    //     descp: "Available in english !!",
         
    // },

    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "Applied mathematics-III",
    //     title: "Previous year question paper(last year)",
    //     descp: "Available in hindi !!",
         
    // },

    
    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "Environmental studies",
    //     title: " Notes in english",
    //     descp: "ES english hand written notes !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "Environmental studies",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
  
    // {
    //     branch: "Information Technology",
    //     sem: "3",
    //     sub: "Environmental studies",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    

    {
        branch: "Information Technology",
        sem: "3",
        sub: "Environmental studies",
        title: "Practicle file ",
        descp: "Available in English !!",
        link:"https://drive.google.com/file/d/1Xcz-vAU64hqz3zVMtewZbJB8TSw5cQRz/view?usp=share_link",
         
    },






// -----------------------------------------------------
    // Information Technology - SEMESTER - 4 (Four)

    // {
    //     branch:"Information Technology",
    //     sem: "4",
    //     sub:"DBMS",
    //     title:"Hand written Notes in hindi",
    //     descp: "DBMS hindi hand written notes !",
         
    // },
    // {
    //     branch:"Information Technology",
    //     sem: "4",
    //     sub: "DBMS",
    //     title: " Hand written Notes in english",
    //     descp: "DBMS english hand written notes !!",
         
    // },
    {
        branch:"Information Technology",
        sem: "4",
        sub: "DBMS",
        title:"Previous year question paper(last year) ",
        descp: "DBMS Available in english !!",
        link: "https://drive.google.com/file/d/1aB5QAGu2ltSHjIVFESVThC1wDBehwmg0/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "4",
        sub: "DBMS",
        title: "Previous year question paper(last year) ",
        descp: "DBMS Available in hindi !!",
        link: "https://drive.google.com/file/d/1T-3Ok3KnZZf40HmJO-a8f10_Df4X-TRC/view?usp=sharing"
    },
    // {
    //     branch: "Information Technology",
    //     sem: "4",
    //     sub: "DBMS",
    //     title: "Important topics ",
    //     descp: "DBMS Available in english !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "4",
    //     sub: "DBMS",
    //     title: "Important topics ",
    //     descp: "DBMS Available in hindi !!",
         
    // },

    // {
    //     branch: "Information Technology",
    //     sem: "4",
    //     sub: "DBMS",
    //     title: "Practicle file ",
    //     descp: "DBMS Available in English !!",
         
    // },

    


    // {
    //     branch: "Information Technology",
    //     sem: "4",
    //     sub: "Operating System",
    //     title: "Hand written Notes in hindi",
    //     descp: "Operating System hindi hand written notes!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "4",
    //     sub: "Operating System",
    //     title: " Hand written Notes in english",
    //     descp: "Operating System english hand written notes!",
         
    // },
    {
        branch: "Information Technology",
        sem: "4",
        sub: "Operating System",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1kwmKweAfgoSlLY-5MQtHFnEdKt-sL0vy/view?usp=sharing"
    },
    {
        branch: "Information Technology",
        sem: "4",
        sub: "Operating System",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1lPiXMxjS7zzhSM03d14XDtyuHnEzQEM2/view?usp=sharing"
    },
    // {
    //     branch: "Information Technology",
    //     sem: "4",
    //     sub: "Operating System",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "4",
    //     sub: "Operating System",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },

    // {
    //     branch: "Information Technology",
    //     sem: "4",
    //     sub: "Operating System",
    //     title: "Practicle file ",
    //     descp: "Available in English !!",
         
    // },

    // {
    //     branch: "Information Technology",
    //     sem: "4",
    //     sub: "Operating System",
    //     title: "Practicle file ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: "Information Technology",
    //     sem: "4",
    //     sub: "E-commerce & Digital marketing",
    //     title: "Hand written Notes in hindi",
    //     descp: "E-commerce & Digital marketing in hindi!",
         
    // },
    // {
    //     branch: "Information Technology",
    //     sem: "4",
    //     sub: "E-commerce & Digital marketing",
    //     title: " Hand written Notes in english ",
    //     descp: "Available in english!",
         
    // },
    {
        branch: "Information Technology",
        sem: "4",
        sub: "E-commerce & Digital marketing",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1lZUa2gmMFn1UcmMB8upTPmLgoSVKaHPz/view?usp=sharing       "
    },
    {
        branch: "Information Technology",
        sem: "4",
        sub: "E-commerce & Digital marketing",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1fpBN9izvqV-BmOUD88eYdYkczhTK_s4L/view?usp=sharing"
    },
//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "E-commerce & Digital marketing",
//         title: "Important topics ",
//         descp: "Available in english !!",
         
//     },
//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "E-commerce & Digital marketing",
//         title: "Important topics ",
//         descp: "Available in hindi !!",
         
//     },



//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "E-commerce & Digital marketing",
//         title: "Practicle file ",
//         descp: "Available in English !!",
         
//     },

   

   

//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "OOP using java",
//         title: "Important topics ",
//         descp: "Available in english !!",
         
//     },
//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "OOP using java",
//         title: "Practicle file ",
//         descp: "Available in English !!",
         
//     },

//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "OOP using java",
//         title: "Practicle file ",
//         descp: "Available in English !!",
         
//     },
//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "OOP using java",
//         title: "OOP using java Hand written Notes",
//         descp: "Available in english !!",
         
//     },
//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "OOP using java",
//         title: "OOP using java Hand written Notes ",
//         descp: "Available in English !!",
         
//     },

//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "OOP using java",
//         title: "Previous year question paper(last year) ",
//         descp: "Available in English !!",
         
//     },








    
//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "UHV",
//         title: " Notes in english",
//         descp: "ES english hand written notes !!",
         
//     },
//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "UHV",
//         title: "Previous year question paper(last year) ",
//         descp: "Available in english !!",
         
//     },
  
//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "UHV",
//         title: "Important topics ",
//         descp: "Available in english !!",
         
//     },
    

//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "UHV",
//         title: "Practicle file ",
//         descp: "Available in English !!",
         
//     },

//    {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "UHV",
//         title: " Notes in english",
//         descp: "ES english hand written notes !!",
         
//     },
//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "UHV",
//         title: "Previous year question paper(last year) ",
//         descp: "Available in english !!",
         
//     },
  
//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "UHV",
//         title: "Important topics ",
//         descp: "Available in english !!",
         
//     },
    

//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "UHV",
//         title: "Practicle file ",
//         descp: "Available in English !!",
         
//     },











//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "EC",
//         title: " Notes in english",
//         descp: "EC english hand written notes !!",
         
//     },
//      {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "EC",
//         title: " Notes in hindi",
//         descp: "EC hindi hand written notes !!",
         
//     },
//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "EC",
//         title: "Previous year question paper(last year) ",
//         descp: "Available in english !!",
         
//     },
//    {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "EC",
//         title: "Previous year question paper(last year) ",
//         descp: "Available in hindi !!",
         
//     },
//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "EC",
//         title: "Important topics ",
//         descp: "Available in english !!",
         
//     },
    

//     {
//         branch: "Information Technology",
//         sem: "4",
//         sub: "EC",
//         title: "Practicle file ",
//         descp: "Available in English !!",
         
//     },
{
        branch: "Information Technology",
        sem: "4",
        sub: "Communication Skill-II",
        title: "Previous year question paper (last year) ",
        descp: "Available in English !!",
        link: "https://drive.google.com/file/d/1nRLOfJK4leQ1hvxu3gPqqZKAKWe6T3ax/view?usp=sharing"
    },
    // {
    //     branch: "Information Technology",
    //     sem: "4",
    //     sub: "Communication Skill-II",
    //     title: "Hand Written Notes in English ",
    //     descp: "Available in English !!",
         
    // },
   



   







    //"Instrumental and control Engineering - SEMESTER -1 (ONE)
    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Applied physics-I",
        title: "Notes in hindi",
        descp: "Physics hindi hand written notes !",
        link: "https://drive.google.com/file/d/17u9I56JAhPDxXFFwmWOwVzfQCnXikCNe/view?usp=sharing"
    },
    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Applied physics-I",
        title: " Notes in english",
        descp: "Physics english hand written notes !!",
        link: "https://drive.google.com/file/d/17u9I56JAhPDxXFFwmWOwVzfQCnXikCNe/view?usp=sharing"
         
    },
    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Applied physics-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1RI6k5UR1ka2QcCJtBKZeSaTKerrOXUzh/view?usp=sharing"
    },
    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Applied physics-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1VLQX0fjeJx38uwIuEeRpO8505Ys_uzi-/view?usp=sharing"
    },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "1",
    //     sub: "Applied physics-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Applied physics-I",
        title: "Important topics numericasl ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/1WRfH9p-5_6kaPAipZqVeFzJgs_k9rLgq/view?usp=share_link",
         
    },

     {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Applied physics-I",
        title: "Practicle file ",
        descp: "Available in English !!",
        link: "https://drive.google.com/file/d/1EB7aNuaZ0N0he2A6ZneJqIRK3_TCnuH5/view?usp=sharing"
    },

    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Applied physics-I",
        title: "Practicle file ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/10jeB6jiZOh9FIe0o4Fl-Ci11gdFWZlac/view?usp=sharing"
    },










    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Syllabus",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/13mxEj4gGKE-WwNM9nU4qPcXHBSJayLuc/view?usp=sharing"
    },
    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Previous Year Question English",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/1hLfaeVv2GRPv1LFcDFT4hkBGCaciLo4r/view?usp=sharing"
    },
    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Previous Year Question Hindi",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/19nGARPnrWqvGQuapxPItNlU1T8MBMuLd/view?usp=sharing"
    },
    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Applied chemistry",
        title: "Notes in hindi",
        descp: "Chemistry hindi hand written notes!",
        link: "https://drive.google.com/file/d/197yQ7Fm-7aUNUkErtk_2OVnr4C55WrEa/view?usp=sharing"
    },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "1",
    //     sub: "Applied chemistry",
    //     title: " Notes in english",
    //     descp: "Chemistry english hand written notes!",
         
       
    // },
    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Applied chemistry",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: " https://drive.google.com/file/d/1U7RP-S-j1ghwoA05ve_Hf2NjbQUEPXBd/view?usp=sharing"
    },
    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Applied chemistry",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1kRQ0APZGFRMMPmmy2LdzgOuANAoLJQbk/view?usp=sharing"            
    },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "1",
    //     sub: "Applied chemistry",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Applied chemistry",
        title: "Important topics ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/1WJye-HzI5_fZ1h5kwmCecglImIaar1f7/view?usp=sharing",
         
    },

    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Communication Skill-I",
        title: "Notes in english",
        descp: "Communication english hand written notes!",
        link:"https://drive.google.com/file/d/1WOsiVeWiO1IcBszjChFagN2tilyz9DNs/view?usp=sharing",
         
    },
    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Communication Skill-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1V0-XevYP2xI7aGDSMpsJr5Xcc-tgdfPv/view?usp=sharing"
    },
    
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "1",
    //     sub: "Communication Skill-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },

    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "1",
    //     sub: "Engineering Drawing-I ",
    //     title: "Notes in hindi",
    //     descp: "Engineering Drawing-I  in hindi!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "1",
    //     sub: "Engineering Drawing-I ",
    //     title: " Notes in english ",
    //     descp: "Engineering drwing in english!",
         
    // },
    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Engineering Drawing-I ",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1YNb7zCTPH_SD6XXS-DG39EBiAtKM62O2/view?usp=share_link",
         
    },
    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Engineering Drawing-I ",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1YR3NZO4MOY1jPsTbY7PjWoDNxAo1GpMI/view?usp=share_link",
         
    },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "1",
    //     sub: "Engineering Drawing-I ",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "1",
    //     sub: "Engineering Drawing-I ",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "1",
    //     sub: "Engineering Mechanics and Materials",
    //     title: "Notes in hindi",
    //     descp: "Engineering Mechanics and Materials hand written notes  in hindi!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "1",
    //     sub: "Engineering Mechanics and Materials",
    //     title: "Notes in english",
    //     descp: "Engineering Mechanics and Materials hand written notes in english!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "1",
    //     sub: "Engineering Mechanics and Materials",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "1",
    //     sub: "Engineering Mechanics and Materials",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "1",
    //     sub: "Engineering Mechanics and Materials",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Workshop-I",
        title: " In hindi",
        descp: "Hand written workshop in hindi!",
        link: "https://drive.google.com/file/d/14Katdl6sFCLD-TZZcN69FTOGmB2kht64/view?usp=sharing"
    },
    {
        branch: "Instrumental and control Eng",
        sem: "1",
        sub: "Workshop-I",
        title: "in english",
        descp: "Hand written workshop in english!",
        link: "https://drive.google.com/file/d/1-hwPUqPFP0Of0kNGTrlw7t3MhwpZ83Ks/view?usp=sharing"
    },







    // -----------------------------------------------------
    //"Instrumental and control Eng - SEMESTER - 2 (TWO)



    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Notes in hindi",
    //     descp: "Physics hindi hand written notes !",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: " Notes in english",
    //     descp: "Physics english hand written notes !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },

    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Applied mathematics-II",
    //     title: "Syllabus",
    //     descp: "Available !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Basics of Information Technology",
    //     title: "Notes in hindi",
    //     descp: "Chemistry hindi hand written notes!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Basics of Information Technology",
    //     title: " Notes in english",
    //     descp: "Chemistry english hand written notes!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Basics of Information Technology",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Basics of Information Technology",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    {
        branch: "Instrumental and control Eng",
        sem: "2",
        sub: "Basics of Information Technology",
        title: "Important topics ",
        descp: "Available in english !!",
        link:"https://drive.google.com/file/d/1WYLpeQyfavltSX152EtztTkUVIIh8Xg-/view?usp=share_link",
         
    },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Basics of Information Technology",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: " Electrical Eng-I ",
    //     title: "Notes in hindi",
    //     descp: "Communication hindi hand written notes!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: " Electrical Eng-I ",
    //     title: "Notes in english",
    //     descp: "Communication english hand written notes!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: " Electrical Eng-I ",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: " Electrical Eng-I ",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: " Electrical Eng-I ",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: " Electrical Eng-I ",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Electronic Components and Devices ",
    //     title: "Notes in hindi",
    //     descp: "Electronic Components and Devices  in hindi!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Electronic Components and Devices ",
    //     title: " Notes in english ",
    //     descp: "Technical drwing in english!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Electronic Components and Devices ",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Electronic Components and Devices ",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Electronic Components and Devices ",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Electronic Components and Devices ",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Workshop-II",
    //     title: " In hindi",
    //     descp: "Hand written workshop in hindi!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "2",
    //     sub: "Workshop-II",
    //     title: "in english",
    //     descp: "Hand written workshop in english!",
         
    // },



    // // -----------------------------------------------------
    // //"Instrumental and control Eng - SEMESTER - 3 (Three)



    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Universal Human Values",
    //     title: "Notes in hindi",
    //     descp: "Physics hindi hand written notes !",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Universal Human Values",
    //     title: " Notes in english",
    //     descp: "Physics english hand written notes !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Universal Human Values",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Universal Human Values",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Universal Human Values",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Universal Human Values",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },

    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Applied mathematics-III",
    //     title: "Syllabus",
    //     descp: "Available !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "TRANSDUCER & APPLICATION ",
    //     title: "Notes in hindi",
    //     descp: "Chemistry hindi hand written notes!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "TRANSDUCER & APPLICATION ",
    //     title: " Notes in english",
    //     descp: "Chemistry english hand written notes!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "TRANSDUCER & APPLICATION ",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "TRANSDUCER & APPLICATION ",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "TRANSDUCER & APPLICATION ",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "TRANSDUCER & APPLICATION ",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: " Electrical  Engineering-II ",
    //     title: "Notes in hindi",
    //     descp: "Communication hindi hand written notes!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: " Electrical  Engineering-II ",
    //     title: "Notes in english",
    //     descp: "Communication english hand written notes!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: " Electrical  Engineering-II ",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: " Electrical  Engineering-II ",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: " Electrical  Engineering-II ",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: " Electrical  Engineering-II ",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Electronic Devices and Circuits",
    //     title: "Notes in hindi",
    //     descp: "Electronic Devices and Circuits in hindi!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Electronic Devices and Circuits",
    //     title: " Notes in english ",
    //     descp: "Technical drwing in english!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Electronic Devices and Circuits",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Electronic Devices and Circuits",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Electronic Devices and Circuits",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Electronic Devices and Circuits",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Electronic Workshop",
    //     title: " In hindi",
    //     descp: "Hand written workshop in hindi!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Electronic Workshop",
    //     title: "in english",
    //     descp: "Hand written workshop in english!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Environmental Studies",
    //     title: "ES In hindi",
    //     descp: "Hand written workshop in hindi!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "3",
    //     sub: "Environmental Studies",
    //     title: "ES in english",
    //     descp: "Hand written workshop in english!",
         
    // },

    {
        branch: "Instrumental and control Eng",
        sem: "3",
        sub: "Environmental studies",
        title: "Practicle file ",
        descp: "Available in English !!",
        link:"https://drive.google.com/file/d/1Xcz-vAU64hqz3zVMtewZbJB8TSw5cQRz/view?usp=share_link",
         
    },


// -----------------------------------------------------
    // Instrumental and control Eng - SEMESTER - 4 (Four)

    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "Principle of Digital Electronics",
    //     title: "Hand written Notes in hindi",
    //     descp: "Principle of Digital Electronics hindi hand written notes !",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "Principle of Digital Electronics",
    //     title: " Hand written Notes in english",
    //     descp: "Principle of Digital Electronics english hand written notes !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "Principle of Digital Electronics",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "Principle of Digital Electronics",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "Principle of Digital Electronics",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "Principle of Digital Electronics",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub:"Network Filters and Transmission Line",
    //     title: "Hand written Notes in hindi",
    //     descp: "Chemistry hindi hand written notes!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub:"Network Filters and Transmission Line",
    //     title: " Hand written Notes in english",
    //     descp: "Chemistry english hand written notes!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub:"Network Filters and Transmission Line",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub:"Network Filters and Transmission Line",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub:"Network Filters and Transmission Line",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub:"Network Filters and Transmission Line",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },


  
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "Communication Skill-II",
    //     title: " Hand written Notes in english ",
    //     descp: "Communication in english!",
         
    // },
    {
        branch: "Instrumental and control Eng",
        sem: "4",
        sub: "Communication Skill-II",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1nRLOfJK4leQ1hvxu3gPqqZKAKWe6T3ax/view?usp=sharing"
    },
    
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "Communication Skill-II",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
   


    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "PROCESS INSTRUMENTATION",
    //     title: "Hand written Notes in hindi",
    //     descp: "PROCESS INSTRUMENTATION hand written notes  in hindi!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "PROCESS INSTRUMENTATION",
    //     title: "Hand written Notes in english",
    //     descp: "PROCESS INSTRUMENTATION hand written notes in english!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "PROCESS INSTRUMENTATION",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "PROCESS INSTRUMENTATION",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "PROCESS INSTRUMENTATION",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "Electronic Instruments and Measurement",
    //     title: "in english",
    //     descp: "Hand written ES in english!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "Electronic Instruments and Measurement",
    //     title: "in hindi",
    //     descp: "Hand written ES in hindi!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "Energy Conservation",
    //     title: "Hand written Notes in hindi",
    //     descp: "Energy Conservation hand written notes  in hindi!",
         
    // },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "Energy Conservation",
    //     title: "Hand written Notes in english",
    //     descp: "Energy Conservation hand written notes in english!",
         
    // },
    {
        branch: "Instrumental and control Eng",
        sem: "4",
        sub: "Energy Conservation",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1-uqqT2vrK7JyDU3ctK_-8zcUMnxJWxX0/view?usp=sharing"
    },
    {
        branch: "Instrumental and control Eng",
        sem: "4",
        sub: "Energy Conservation",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1Ssz8u9mGiSKrMuaQBXQsfVoa8zjyvO_B/view?usp=sharing"
    },
    // {
    //     branch: "Instrumental and control Eng",
    //     sem: "4",
    //     sub: "Energy Conservation",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },







    // Mechanical Eng - SEMESTER -1 (ONE)
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Applied physics-I",
        title: "Notes in hindi",
        descp: "Physics hindi hand written notes !",
        link: "https://drive.google.com/file/d/17u9I56JAhPDxXFFwmWOwVzfQCnXikCNe/view?usp=sharing"
    },
    // {
    //     branch: "Mechanical",
    //     sem: "1",
    //     sub: "Applied physics-I",
    //     title: " Notes in english",
    //     descp: "Physics english hand written notes !!",
         
    // },
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Applied physics-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1RI6k5UR1ka2QcCJtBKZeSaTKerrOXUzh/view?usp=sharing"
    },
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Applied physics-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1VLQX0fjeJx38uwIuEeRpO8505Ys_uzi-/view?usp=sharing"
    },
    // {
    //     branch: "Mechanical",
    //     sem: "1",
    //     sub: "Applied physics-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Applied physics-I",
        title: "Important topics numerical ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/1WRfH9p-5_6kaPAipZqVeFzJgs_k9rLgq/view?usp=share_link",
         
    },
     {
        branch: "Mechanical",
        sem: "1",
        sub: "Applied physics-I",
        title: "Practicle file ",
        descp: "Available in English !!",
        link: "https://drive.google.com/file/d/1EB7aNuaZ0N0he2A6ZneJqIRK3_TCnuH5/view?usp=sharing"
    },

    {
        branch: "Mechanical",
        sem: "1",
        sub: "Applied physics-I",
        title: "Practicle file ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/10jeB6jiZOh9FIe0o4Fl-Ci11gdFWZlac/view?usp=sharing"
    },












    {
        branch: "Mechanical",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Syllabus",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/13mxEj4gGKE-WwNM9nU4qPcXHBSJayLuc/view?usp=sharing"
    },
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Previous Year Question English",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/1hLfaeVv2GRPv1LFcDFT4hkBGCaciLo4r/view?usp=sharing"
    },
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Applied mathematics-I",
        title: "Previous Year Question Hindi",
        descp: "Available  !!",
        link: "https://drive.google.com/file/d/19nGARPnrWqvGQuapxPItNlU1T8MBMuLd/view?usp=sharing"
    },
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Applied chemistry",
        title: "Notes in hindi",
        descp: "Chemistry hindi hand written notes!",
        link: "https://drive.google.com/file/d/197yQ7Fm-7aUNUkErtk_2OVnr4C55WrEa/view?usp=sharing"
    },
    // {
    //     branch: "Mechanical",
    //     sem: "1",
    //     sub: "Applied chemistry",
    //     title: " Notes in english",
    //     descp: "Chemistry english hand written notes!",
         
    // },
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Applied chemistry",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1U7RP-S-j1ghwoA05ve_Hf2NjbQUEPXBd/view?usp=sharing             "
    },
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Applied chemistry",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1kRQ0APZGFRMMPmmy2LdzgOuANAoLJQbk/view?usp=sharing"
    },
    // {
    //     branch: "Mechanical",
    //     sem: "1",
    //     sub: "Applied chemistry",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Applied chemistry",
        title: "Important topics ",
        descp: "Available in hindi !!",
        link:"https://drive.google.com/file/d/1WJye-HzI5_fZ1h5kwmCecglImIaar1f7/view?usp=sharing",
         
    },
    
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Communication Skill-I",
        title: "Notes in english",
        descp: "Communication english hand written notes!",
        link:"https://drive.google.com/file/d/1WOsiVeWiO1IcBszjChFagN2tilyz9DNs/view?usp=sharing",
         
    },
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Communication Skill-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1V0-XevYP2xI7aGDSMpsJr5Xcc-tgdfPv/view?usp=sharing"
    },
    
    // {
    //     branch: "Mechanical",
    //     sem: "1",
    //     sub: "Communication Skill-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    
    // {
    //     branch: "Mechanical",
    //     sem: "1",
    //     sub: "Engineering Drawing-I",
    //     title: "Notes in hindi",
    //     descp: "Engineering Drawing-I in hindi!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "1",
    //     sub: "Engineering Drawing-I",
    //     title: " Notes in english ",
    //     descp: "Engineering drawing drwing in english!",
         
    // },
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Engineering Drawing-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in english !!",
        link: "https://drive.google.com/file/d/1YNb7zCTPH_SD6XXS-DG39EBiAtKM62O2/view?usp=share_link", 
    },
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Engineering Drawing-I",
        title: "Previous year question paper(last year) ",
        descp: "Available in hindi !!",
        link: "https://drive.google.com/file/d/1YR3NZO4MOY1jPsTbY7PjWoDNxAo1GpMI/view?usp=share_link", 
    },
    // {
    //     branch: "Mechanical",
    //     sem: "1",
    //     sub: "Engineering Drawing-I",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "1",
    //     sub: "Engineering Drawing-I",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Basics of Information Technology",
        title: "Notes in hindi",
        descp: "Basics of Information Technology hand written notes  in hindi!",
        link: "https://drive.google.com/file/d/17vvCoBDS7Z8yPyKu1prF1UPAccM9XxB8/view?usp=sharing"
    },
    // {
    //     branch: "Mechanical",
    //     sem: "1",
    //     sub: "Basics of Information Technology",
    //     title: "Notes in english",
    //     descp: "Basics of Information Technology hand written notes in english!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "1",
    //     sub: "Basics of Information Technology",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "1",
    //     sub: "Basics of Information Technology",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Basics of Information Technology",
        title: "Important topics ",
        descp: "Available in english !!",
        link:"https://drive.google.com/file/d/1WYLpeQyfavltSX152EtztTkUVIIh8Xg-/view?usp=share_link",
         
    },

    {
        branch: "Mechanical",
        sem: "1",
        sub: "Workshop",
        title: " In hindi",
        descp: "Hand written workshop in hindi!",
        link: "https://drive.google.com/file/d/14Katdl6sFCLD-TZZcN69FTOGmB2kht64/view?usp=sharing"
    },
    {
        branch: "Mechanical",
        sem: "1",
        sub: "Workshop",
        title: "in english",
        descp: "Hand written workshop in english!",
        link: "https://drive.google.com/file/d/1-hwPUqPFP0Of0kNGTrlw7t3MhwpZ83Ks/view?usp=sharing"
    },
    // -----------------------------------------------------
    // Mechanical Eng Eng - SEMESTER - 2 (TWO)

    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Hand written Notes in hindi",
    //     descp: "Physics hindi hand written notes !",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: " Hand written Notes in english",
    //     descp: "Physics english hand written notes !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Applied physics-II",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Applied Mechanics",
    //     title: "Hand written Notes in hindi",
    //     descp: "Chemistry hindi hand written notes!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Applied Mechanics",
    //     title: " Hand written Notes in english",
    //     descp: "Chemistry english hand written notes!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Applied Mechanics",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Applied Mechanics",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Applied Mechanics",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Applied Mechanics",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "General Engineering",
    //     title: "Hand written Notes in hindi",
    //     descp: "General Engineering in hindi!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "General Engineering",
    //     title: " Hand written Notes in english ",
    //     descp: "Technical drwing in english!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "General Engineering",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "General Engineering",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "General Engineering",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "General Engineering",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },

    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Engineering Drawing -II",
    //     title: "Hand written Notes in hindi",
    //     descp: "Engineering Drawing -II hand written notes  in hindi!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Engineering Drawing -II",
    //     title: "Hand written Notes in english",
    //     descp: "Engineering Drawing -II hand written notes in english!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Engineering Drawing -II",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Engineering Drawing -II",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Engineering Drawing -II",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Applied mathematics-II",
    //     title: "Syllabus",
    //     descp: "Available  !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Workshop-II",
    //     title: "file in hindi",
    //     descp: "Hand written workshop in hindi!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "2",
    //     sub: "Workshop-II",
    //     title: "file in english",
    //     descp: "Hand written workshop in hindi!",
         
    // },

    // -----------------------------------------------------
    // Mechanical  Eng - SEMESTER - 3 (Three)

    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Engineering Materials",
    //     title: "Hand written Notes in hindi",
    //     descp: "Physics hindi hand written notes !",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Engineering Materials",
    //     title: " Hand written Notes in english",
    //     descp: "Physics english hand written notes !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Engineering Materials",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Engineering Materials",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Engineering Materials",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Engineering Materials",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Mechanics of Solids",
    //     title: "Hand written Notes in hindi",
    //     descp: "Chemistry hindi hand written notes!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Mechanics of Solids",
    //     title: " Hand written Notes in english",
    //     descp: "Chemistry english hand written notes!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Mechanics of Solids",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Mechanics of Solids",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Mechanics of Solids",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Mechanics of Solids",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Thermal Engineering",
    //     title: "Hand written Notes in hindi",
    //     descp: "Thermal Engineering in hindi!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Thermal Engineering",
    //     title: " Hand written Notes in english ",
    //     descp: "Technical drwing in english!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Thermal Engineering",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical ",
    //     sem: "3",
    //     sub: "Thermal Engineering",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical ",
    //     sem: "3",
    //     sub: "Thermal Engineering",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical" ,
    //     sem: "3",
    //     sub: "Thermal Engineering",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },

    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Computer Aided Drafting and 3D Modelling",
    //     title: "Hand written Notes in hindi",
    //     descp: "Computer Aided Drafting and 3D Modelling hand written notes  in hindi!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Computer Aided Drafting and 3D Modelling",
    //     title: "Hand written Notes in english",
    //     descp: "Computer Aided Drafting and 3D Modelling hand written notes in english!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Computer Aided Drafting and 3D Modelling",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Computer Aided Drafting and 3D Modelling",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Computer Aided Drafting and 3D Modelling",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Applied mathematics-III",
    //     title: "Syllabus",
    //     descp: "Available  !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Workshop Technology",
    //     title: "file in hindi",
    //     descp: "Hand written workshop in hindi!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "3",
    //     sub: "Workshop Technology",
    //     title: "file in english",
    //     descp: "Hand written workshop in hindi!",
         
    // },

    // -----------------------------------------------------
    // Mechanical  Eng - SEMESTER - 4 (Four)

    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Refrigeration and Air Conditioning ",
    //     title: "Hand written Notes in hindi",
    //     descp: "Physics hindi hand written notes !",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Refrigeration and Air Conditioning ",
    //     title: " Hand written Notes in english",
    //     descp: "Physics english hand written notes !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Refrigeration and Air Conditioning ",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Refrigeration and Air Conditioning ",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Refrigeration and Air Conditioning ",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Refrigeration and Air Conditioning ",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Hydraulics and Pneumatics",
    //     title: "Hand written Notes in hindi",
    //     descp: "Chemistry hindi hand written notes!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Hydraulics and Pneumatics",
    //     title: " Hand written Notes in english",
    //     descp: "Chemistry english hand written notes!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Hydraulics and Pneumatics",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Hydraulics and Pneumatics",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Hydraulics and Pneumatics",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Hydraulics and Pneumatics",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Computer Aided Design and Manufacturing",
    //     title: "Hand written Notes in hindi",
    //     descp: "Computer Aided Design and Manufacturing in hindi!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Computer Aided Design and Manufacturing",
    //     title: " Hand written Notes in english ",
    //     descp: "Technical drwing in english!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Computer Aided Design and Manufacturing",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Computer Aided Design and Manufacturing",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Computer Aided Design and Manufacturing",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Computer Aided Design and Manufacturing",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },

    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Environmental Studies ",
    //     title: "Hand written Notes in hindi",
    //     descp: "Environmental Studies  hand written notes  in hindi!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Environmental Studies ",
    //     title: "Hand written Notes in english",
    //     descp: "Environmental Studies  hand written notes in english!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Environmental Studies ",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Environmental Studies ",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    {
        branch: "Mechanical",
        sem: "3",
        sub: "Environmental studies",
        title: "Practicle file ",
        descp: "Available in English !!",
        link:"https://drive.google.com/file/d/1Xcz-vAU64hqz3zVMtewZbJB8TSw5cQRz/view?usp=share_link",
         
    },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Environmental Studies ",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Communication-II",
    //     title: "Notes in English",
    //     descp: "Available  !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Communication-II",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Communication-II",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Engery Conservation",
    //     title: "Hand written Notes in hindi",
    //     descp: "Physics hindi hand written notes !",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Engery Conservation",
    //     title: " Hand written Notes in english",
    //     descp: "Physics english hand written notes !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Engery Conservation",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Engery Conservation",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Engery Conservation",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Engery Conservation",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },

    
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Universal Human Values",
    //     title: "Hand written Notes in hindi",
    //     descp: "Physics hindi hand written notes !",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Universal Human Values",
    //     title: " Hand written Notes in english",
    //     descp: "Physics english hand written notes !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Universal Human Values",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Universal Human Values",
    //     title: "Previous year question paper(last year) ",
    //     descp: "Available in hindi !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Universal Human Values",
    //     title: "Important topics ",
    //     descp: "Available in english !!",
         
    // },
    // {
    //     branch: "Mechanical",
    //     sem: "4",
    //     sub: "Universal Human Values",
    //     title: "Important topics ",
    //     descp: "Available in hindi !!",
         
    // },
];

    const openLink = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }


    var FilteredArray = newArray.filter(function (el) {
        return el.branch === props.Branch && el.sem === props.semNumber && el.sub === props.Subject;
    }
    );
    // console.log("d", FilteredArray);
    return (
        <>
            <div className="container">
                <div className="container d-flex justify-content-center align-item-center">
                    <button className="btn btn-primary mx-1 my-3" onClick={(e) => props.setDisplay('Home')}>Home</button>
                    <button className="btn btn-primary mx-1 my-3" onClick={(e) => props.setDisplay('Branch')}>Change Branch</button>
                    <button className="btn btn-primary mx-1 my-3" onClick={(e) => props.setDisplay('Semester')}>Change Semester</button>
                    <button className="btn btn-primary mx-1 my-3" onClick={(e) => props.setDisplay('Subject')}>Change Subject</button>
                </div>
                <div className="container">
                    <h3 className="text-center">Branch: {props.Branch}</h3>
                    <h4 className="text-center mb-4">Subject: {props.Subject}</h4>
                    <h4 className="text-center mb-4">Semester: {props.semNumber}</h4>
                </div>

                <div className='my-3'>
                    <h5 className="text-center">All Availiable Resources for {props.Subject}</h5>
                    <div className="alert alert-primary alert-dismissible fade show" role="alert">
                        <strong>Note:</strong> We are still uploading the Notes & other Pdf's , all notes for the Semester will be availiable soon.
                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                    <div className="alert alert-primary alert-dismissible fade show" role="alert">
                        <strong>Note:</strong> हम अभी भी नोट्स और अन्य पीडीएफ अपलोड कर रहे हैं, सेमेस्टर के सभी नोट्स जल्द ही उपलब्ध होंगे।

                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                    {FilteredArray.map((arr, index) => (
                        <div key={index}>
                            <div className="row my-3">
                                <div className="">
                                    <div id="list-example" className="list-group">
                                        <div className="list-group-item list-group-item-action"
                                        // onClick={(e) => { props.setDisplay('Semester'); props.setBranch('Computer Science') }}
                                        >
                                            <h5>  {arr.title}</h5>
                                            <h6> {arr.descp}</h6>
                                            <button className="btn btn-sm btn-danger" onClick={() => openLink(arr.link)}>Download</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>))}
                </div>
            </div>
        </>
    )
}

export default Downloadpage